import { solicitacaoStoreMiddleware } from '@/components/SolicitacaoCirurgia/store/solicitacao-store-middleware'
import { clearCPF, clearEmptyFields, formatPhoneMask, convertToGradeMedicaEvento, setOPMEsToSave, flatPhone, setValorDoCampoUnico, getProcedimentoIdFromProcedimentos, opcaoHabilitadoShared, campoHabilitadoShared } from '@/utils/common'
/* eslint-disable arrow-body-style */
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
// eslint-disable-next-line
import {
  SolicitacaoCirurgia,
  ModeloCirurgia,
  LocalAtendimento,
  Convenio,
  Procedimento,
  Hemocomponente,
  ConsultaPacienteCpf,
  Cid,
  TipoDocumentoUpload,
  Plano,
  Paciente,
  ReservaHemocomponente,
  NovoFornecedor,
  NovoOPME,
  GrupoOpme,
  GrupoOpmes,
  GradeMedicaEvento,
  TempoDeDoenca,
  Laudo,
  TipoPacienteEnum,
  CentroCirurgico,
  OpmeMaterial,
  TipoDocumentoBuscaPacienteEnum,
// eslint-disable-next-line
} from '@/types/_'
import { SolicitacaoCirurgiaImp } from '@/types/core'
import moment from 'moment-timezone'
import _, { forEach } from 'lodash'
import { AnestesistaHospital, Fornecedor, SolicitacaoGrupoOpme, Acoes } from '@/types/interfaces/Solicitacao'
import ProtocoloApi from '@/Apis/Agendamento/Services/ProtocoloApi'
import EventBus from '@/plugins/EventBus'
import Apis from '@/Apis/_'
import SolicitacaoCirurgiaApi from '@/Apis/Agendamento/Services/SolicitacaoCirurgiaApi'
import AgendamentoApi from '@/Apis/Agendamento/Services/AgendamentoApi'
// @ts-ignore
import Paises from '@/json/ListaPaises'
import { IDocumentoObrigatorio } from '@/types/interfaces/documentacao-obrigatoria/documento-obrigatorio.interface'
import { IProtocoloJustificativaDoMedico } from '@/types/interfaces/protocolo/protocolo-justificativa-do-medico.interface'
import { StatusDoProtocoloEnum } from '../../../types/interfaces/protocolo/status-do-protocolo.enum'
import { IProtocolo,
  IProtocoloTecnicaDeCirurgia,
  SolicitacaoOpme,
  IProtocoloKitDeOpmeV2,
  IProtocoloMaterialDoKitV2,
  IProtocoloMaterialDoKitV2Solicitacao,
  IProtocoloKitDeOpmeV2Solicitacao,
  IProtocoloMateriaisPorGrupoV2Solicitacao,
  IProtocoloMaterialAgrupado } from '../../../types/interfaces/protocolo/protocolo.interface'
import { CaixaCirurgica, ProtocoloDeCirurgiaDaSolicitacao, SolicitacaoComorbidadesDoPaciente } from '../../../types/interfaces/SolicitacaoCirurgia'
import { SolicitacaoTipoAnestesia } from '../../../types/interfaces/SolicitacaoTipoAnestesia'

@Module({ namespaced: true, name: 'SolicitacaoCirurgiaStore' })
export default class SolicitacaoCirurgiaStore extends VuexModule {
  canSuggestProtocol = true

  public consultaPacienteCpfDefault: ConsultaPacienteCpf = {
    convenioPlano: {
      convenioId: '',
      carteirinha: '',
      planoId: '',
      particular: false,
    },
    descricao: '',
    paciente: {
      celular: '',
      cpf: '',
      rgh: '',
      peso: null,
      altura: null,
      tipoPaciente: null,
      rne: null,
      passaporte: null,
      paisId: null,
      cpfResponsavel: '',
      certidaoNascimentoLivro: '',
      certidaoNascimentoFolha: '',
      certidaoNascimentoTermo: '',
      nomeSocial: '',
      dataNascimento: '',
      id: '',
      nome: '',
      nomeMae: '',
      sexo: '',
      telefone: '',
      carteirinha: '',
      convenioId: '',
      planoId: '',
      pacienteNaoPossuiCpf: false,
      idade: null,
      categoriaId: '',
      hisId: '',
    },
    pacientes: [],
  }

  public consultaPacienteCpf: ConsultaPacienteCpf = { ...this.consultaPacienteCpfDefault }
  public procedimentosAssociados: Procedimento[] = []
  private pacienteDefault: Paciente = {
    carteirinha: '',
    celular: '',
    email: '',
    convenioId: '',
    planoId: '',
    cpf: '',
    rgh: '',
    peso: null,
    altura: null,
    tipoPaciente: null,
    rne: null,
    passaporte: null,
    paisId: null,
    cpfResponsavel: '',
    certidaoNascimentoLivro: '',
    certidaoNascimentoFolha: '',
    certidaoNascimentoTermo: '',
    nomeSocial: '',
    dataNascimento: '',
    id: '',
    idade: null,
    nome: '',
    nomeMae: '',
    pacienteNaoPossuiCpf: false,
    sexo: '',
    telefone: '',
    categoriaId: '',
    hisId: '',
    categoriaCoberturaVigente: undefined,
  }

  private pacientesListaDefault: Paciente[] = []
  public pacientesLista: Paciente[] = [...this.pacientesListaDefault]

  private reservaHemocomponenteDefault: ReservaHemocomponente = {
    concentradoHemacias: {
      quantidade: 0,
      value: false,
    },
    concentradoPlaquetas: {
      quantidade: 0,
      value: false,
    },
    crioprecipitado: {
      quantidade: 0,
      value: false,
    },
    plasmaFrescoCongelado: {
      quantidade: 0,
      value: false,
    },
    tipagemSanguinea: {
      value: false,
    },
    tipagemSanguineaABORHPAI: {
      quantidade: 0,
      value: false,
    },
    semReserva: {
      quantidade: 0,
      value: false,
    },
  }

  private tempoDeDoencaDefault: TempoDeDoenca = {
    anos: 0,
    meses: 0,
    dias: 0,
  }

  private solicitacaoCirurgiaDefault: SolicitacaoCirurgia = {
    id: '',
    modeloCirurgiaId: '',
    hospitalId: '',
    medicoSolicitante: {
      conselhoTipo: 'CRM',
      conselhoNumero: '',
      conselhoUf: '',
      email: '',
      id: '',
      nome: '',
      urlAssinatura: '',
    },
    medicoSolicitanteId: '',
    medicoPrescritorId: '',
    possuiConvenioAssociado: '',
    convenioAssociadoId: null,
    planoAssociadoId: null,
    categoriaAssociadaId: null,
    hospital: {
      id: '',
      nome: '',
      urlAssinatura: '',
      hospitalFazConsultaCoberturaVigente: undefined,
      tipoDeCoberturaVigente: undefined,
      usaProcedimentosApenasHospitalDia: false,
      hospitalExigeDocumentacaoDoPacienteQuandoCaraterUrgencia: false,
      utilizaTipoAcomodacaoHospital: undefined,
    },
    localAtendimentoId: null,
    especificacaoExameIntraOperatorio: '',
    examesIntraOperatorios: {
      anatomiaPatologica: false,
      anatomiaPatologicaHospitalOuParticular: null,
      anatomiaPatologicaParticularLocal: null,
      biobanco: false,
      biopsia: false,
      biopsiaHospitalOuParticular: null,
      biopsiaParticularLocal: null,
      broncoscopiaFlexivel: false,
      catho: false,
      cellSaver: false,
      colangiografia: false,
      colangiopancreatografiaRetrograda: false,
      colonoscopia: false,
      congelacaoBACCHI: false,
      congelacaoFilomenaMarinhoCarvalho: false,
      congelacaoIPC: false,
      congelacaoMultipat: false,
      congelacaoPathos: false,
      congelacaoFerdinando: false,
      congelacaoSalomao: false,
      congelacaoLoccus: false,
      congelacaoFleury: false,
      congelacaoEinstein: false,
      congelacaoBML: false,
      congelacaoCIPAC: false,
      congelacaoPathology: false,
      culturaSonicacao: false,
      dimen: false,
      ecocardiograma: false,
      ecointraoperatório: false,
      ecotransesofagico: false,
      endoscopia: false,
      escleraUnicamp: false,
      examesLaboratoriais: false,
      fivmed: false,
      insite: false,
      mamografia: false,
      medicinaNuclear: false,
      monitorizacaoNeurofisiologica: false,
      nervoNIM: false,
      neuronavegacao: false,
      outros: false,
      outrosEspecificar: null,
      potencialEvocado: false,
      pth: false,
      radioterapia: false,
      ressonancia: false,
      rxScopia: false,
      semExameIntraoperatorio: false,
      tipagemSanguinea: false,
      tomografia: false,
      tomografiaParaEstereotaxia: false,
      transporte: false,
      udo: false,
      ultrassonografiaDeImagem: false,
      ultrassonografiaIntraoperatoria: false,
      ultrassonografiaIntraoperatoriaEquipeDoHospital: null,
      ultrassonografiaLaparoscopio: false,
      ultrassonografiaRadiologia: false,
      ultrassonografiaRadiologiaAcompanhamento: false,
      anestesiaAMD: false,
      exameEcoIntraoperatorio: false,
      exameUsgIntraoperatorio: false,
      gdlReservaDeUtiAdulto: false,
      gdlReservaDeUtiPediatrica: false,
      gdlUiHemoAngio: false,
      laboratorioPthRapido: false,
      servicoAnextesia: false,
      laboratorioBacchi: false,
      laboratorioFilomenaMarinoCarvalho: false,
      laboratorioPathosDiagnosticosMedicos: false,
      laboratorioLocus: false,
      laboratorioFleury: false,
      anestesiaGaap: false,
      broncoscopista: false,
      exameMamografia: false,
      exameRxIntraoperatorio: false,
      reservaDeRoll: false,
    },
    opcaoDataPrevisto1: '',
    opcaoDataPrevisto2: '',
    opcaoDataPrevisto3: '',
    reservaHemocomponentes: {
      concentradoHemacias: {
        quantidade: 0,
        value: false,
      },
      concentradoPlaquetas: {
        quantidade: 0,
        value: false,
      },
      crioprecipitado: {
        quantidade: 0,
        value: false,
      },
      plasmaFrescoCongelado: {
        quantidade: 0,
        value: false,
      },
      tipagemSanguinea: {
        value: false,
      },
      tipagemSanguineaABORHPAI: {
        quantidade: 0,
        value: false,
      },
      semReserva: {
        quantidade: 0,
        value: false,
      },
    },
    diagnosticoJustificativa: '',
    alergiaLatex: '',
    alergiaContraste: null,
    testeCovid: null,
    marcapasso: null,
    reoperacao: null,
    precaucoes: '',
    carater: '',
    procedimento: {} as Procedimento,
    procedimentosAssociados: [],
    reservaUTI: '',
    pacienteEstaInternado: null,
    diaria: null,
    instrucaoDataPrevista: '',
    honorarioMedico: '',
    honorarioMedicoDocumento: null,
    codigoPrestador: '',
    temMedicamentosEspeciais: null,
    temMedicacaoContinua: null,
    medicamentosEspeciais: '',
    medicacaoContinua: '',
    temPrevisaoUsoQuimioterapico: null,
    previsaoUsoQuimioterapico: '',
    anestesiaDoHospital: '',
    honorarioAnestesista: '',
    honorarioAnestesistaDocumento: null,
    tipoAnestesia: null,
    comorbidade: null,
    medicacaoDapt: null,
    funcaoRenal: null,
    complexidade: null,
    solicitacaoMedicoConvidado: {
      medicoConvidado: '',
      celular: '',
      codigoConselho: '',
      nome: '',
    },
    nome: '',
    paciente: {
      carteirinha: '',
      celular: '',
      email: '',
      convenioId: '',
      planoId: '',
      cpf: '',
      rgh: '',
      peso: null,
      altura: null,
      tipoPaciente: null,
      rne: null,
      passaporte: null,
      paisId: null,
      cpfResponsavel: '',
      certidaoNascimentoLivro: '',
      certidaoNascimentoFolha: '',
      certidaoNascimentoTermo: '',
      nomeSocial: '',
      dataNascimento: '',
      id: '',
      idade: null,
      nome: '',
      nomeMae: '',
      pacienteNaoPossuiCpf: false,
      sexo: '',
      telefone: '',
      categoriaId: '',
      hisId: '',
      categoriaCoberturaVigente: undefined,
    },
    comorbidadesDoPaciente: [],
    historicoDeCardiopatiaHisquemicaEspecificar: null,
    historicoDeInsuficienciaCardiacaEspecificar: null,
    historicoDeDoencaVascularCerebralEspecificar: null,
    diabetesEspecificar: null,
    obesidadeEspecificar: null,
    arritimiaCardiacaPorFibrilacaoAuricularEspecificar: null,
    pacientePossuiLiberacaDoClinicoOuCardiologistaEspecificar: null,
    especificarPrecaucoes: '',
    anestesistaCrm: '',
    nomeAnestesista: '',
    anestesista: null,
    anestesistaId: null,
    temSolicitacaoReservaDeSangue: '',
    instrumentalAdicional: '',
    tempoCirurgia: 0,
    justificativaDePrazo: '',
    dataAgendamentoVirtual: null,
    diferencaDeAcomodacao: null,
    temEquipeMedica: null,
    temOpmeDoConsultorio: null,
    temInstrumentadorExterno: null,
    equipeMedica: '',
    equipeCirurgica: [],
    opmeDoConsultorio: '',
    instrumentadorExterno: '',
    registraProtocoloDeRecuperacaoPrecoce: false,
    diariaUti: null,
    tipoAcomodacao: null,
    hospitalTipoAcomodacaoId: null,
    tecnicaDaCirurgia: null,
    temInternacaoDeVespera: null,
    internacaoDeVespera: '',
    temReservaHemocomponentesSimples: null,
    pesoDoPaciente: null,
    tempoDeDoenca: { ...this.tempoDeDoencaDefault },
    farmacia: null,
    tipoProcedimento: null,
    tipoInternacao: null,
    nomeCirurgia: null,
    medicoSolicitouDataVirtual: false,
    grupoDeOpme: {
      descricao: '',
      opmes: [],
    },
    protocoloDeCirurgia: {
      segueOProtocolo: null,
      statusDoProtocolo: '',
      protocoloDeCirurgiaId: '',
      tecnicaDeCirurgiaId: '',
      tecnicaDeCirurgia: {
        id: '',
        nome: '',
      },
      medicoRecusouSeguirOProtocolo: false,
      kitDeOpmeId: '',
    } as ProtocoloDeCirurgiaDaSolicitacao,
    criadaComoPreReserva: false,
    configuracoes: {
      paciente: {
        celular: true,
        cpf: true,
        tipoPaciente: true,
        rne: true,
        passaporte: true,
        paisId: true,
        cpfResponsavel: true,
        certidaoNascimentoLivro: true,
        certidaoNascimentoFolha: true,
        certidaoNascimentoTermo: true,
        nomeSocial: true,
        dataNascimento: true,
        nome: true,
        nomeMae: true,
        sexo: true,
        telefone: true,
        carteirinha: true,
        convenioId: true,
        planoId: true,
        pacienteNaoPossuiCpf: true,
        idade: true,
        categoriaId: true,
      },
      prazoEmDiasParaTriagem: 0,
      prazoMaximoEmDiasParaAgendamento: 0,
    },
    caixasCirurgicas: [],
    classificacaoCirurgia: null,
    acoes: {
      podeEditarFormularioDaAutorizacao: false,
      podeFinalizarSolicitacao: false,
      medicoPodeEnviarParaOAutorizador: false,
    },
    numeroDoAtendimentoAoPacienteNoHospital: '',
    principaisResultadosProvasDiagnosticas: '',
    justificativaTecnica: '',
  }

  private grupoOpmeDefault: GrupoOpme = {
    medicoId: '',
    descricao: '',
    justificativa: '',
    procedimentoId: '',
    solicitacaoId: '',
    fornecedor1Id: '',
    fornecedor2Id: '',
    fornecedor3Id: '',
    opmes: [
      {
        gradeCompleta: false,
        opme: {
          possuiGrade: false,
          id: '',
          descricao: '',
        },
        opmeId: '',
        quantidade: 0,
        quantidadeMinima: 0,
        quantidadeMaxima: 0,
        procedimentoBilateral: {
          quantidadeMaxima: 0,
        },
        medidaTamanho: '',
        fornecedores: [],
      },
    ],
    fornecedor1: {
      fabricante: '',
      fornecedorId: '',
      homologadoConvenio: false,
      homologadoHospital: false,
      nome: '',
    },
    fornecedor2: {
      fabricante: '',
      fornecedorId: '',
      homologadoConvenio: false,
      homologadoHospital: false,
      nome: '',
    },
    fornecedor3: {
      fabricante: '',
      fornecedorId: '',
      homologadoConvenio: false,
      homologadoHospital: false,
      nome: '',
    },
    id: '',
    procedimentoCodigo: '',
    tipo: '',
  }

  private novoFornecedorDefault: NovoFornecedor = {
    nomeFornecedor: '',
    nomeFabricante: '',
    medicoId: '',
    hospitalId: '',
    contato: '',
  }

  private novoOPMEDefault: NovoOPME = {
    medicoId: '',
    descricao: '',
    possuiGrade: false,
  }

  private opmeDefault: any = {
    opme: null,
    quantidade: 0,
    quantidadeMinima: 0,
    quantidadeMaxima: 0,
    procedimentoBilateral: {
      quantidadeMaxima: 0,
    },
    possuiGrade: false,
    observacao: null,
    fornecedor1Id: '',
    fornecedor2Id: '',
    fornecedor3Id: '',
  }

  public opme: any = { ...this.opmeDefault }

  public surgerySolicitationActions: Acoes

  private opmeGrupoDefault: any[] = [this.opme]

  public opmeGrupo: any[] = [...this.opmeGrupoDefault]
  public opmeGrupoInicial: any[] = []
  public opmeGrupoId: string = ''

  private categoriasDefault: any[] = []

  public novoFornecedor: NovoFornecedor = { ...this.novoFornecedorDefault }

  public solicitacaoCirurgia: SolicitacaoCirurgia = { ...this.solicitacaoCirurgiaDefault }
  public convenios: Convenio[] = []
  public conveniosAssociados: Convenio[] = []
  public categorias: any[] = [...this.categoriasDefault]
  public categoriasAssociadas: any[] = [...this.categoriasDefault]
  public planos: Plano[] = []
  public planosAssociados: Plano[] = []
  public laudos: Laudo[] = []
  public laudosPaciente: Laudo[] = []
  public laudosDiversos: Laudo[] = []
  public laudosTermoDeConsentimento: Laudo[] = []
  public laudosOrcamentoDeCirurgiaParticularAprovado: Laudo[] = []
  public modelosCirurgia: ModeloCirurgia[] = [{ id: '', nomeCirurgia: 'Nova Cirurgia', tipo: '' }]
  public locaisAtendimento: LocalAtendimento[] = []
  public hospitalId: string = ''
  public medicoSolicitanteId: string = ''
  public firstStep: boolean = true
  public disabledForm: boolean = false
  public step: number = 0
  public template: any = { formulario: {}, hospital: {}, porConvenio: [] }
  public cids: Cid[] = []
  public hemocomponentesCheckbox: string[] = []
  public examesIntraOperatoriosCheckbox: string[] = []
  public habilitarGrade: boolean = false
  public instrumentos: any[] = []
  public medicoGrupoOpmes: GrupoOpme[] = []
  public fornecedores: Fornecedor[] = []
  public grupoOpme: GrupoOpme = { ...this.grupoOpmeDefault }
  public novoOPME: NovoOPME = { ...this.novoOPMEDefault }
  public listaMedicoOpme: any[] = []
  public solicitacaoMaterialOptions: MaterialOptions[] = []
  public opmesOpcionaisOptions: MaterialOptions[] = []
  public opmesOpcionaisOptionsMaximumQuantity: number = 0
  public opmeFornecedorIndex: number | null = null
  public centroCirurgico: CentroCirurgico[] = []
  public tipoAnestesiaCheckbox: string[] = []
  public outrosTipoAnestesia: string | null
  public comorbidadesDoPacienteCheckbox: string[] = []
  public comorbidadesDoPaciente: SolicitacaoComorbidadesDoPaciente[] = []
  public anestesistasHospital: AnestesistaHospital[] = []
  public reservaSalaId: string = ''

  public modal = {
    opme: false,
    dataCirurgia: false,
    buscarPaciente: false,
    previaCirurgica: false,
    cadastrarMaterial: false,
    cadastrarFornecedor: false,
    caixaCirurgica: false,
    listaDeAnestesistas: false,
    procedimentosApenasHospitalDiaWarning: false,
  }

  private dataCirurgiaDefault: any = {
    dataCirurgia: null,
    hora: null,
  }

  public dataCirurgia: any = { ...this.dataCirurgiaDefault }

  solicitacaoCirurgiaImp: SolicitacaoCirurgiaImp.ISolicitacaoCirurgiaImp
    = new SolicitacaoCirurgiaImp.SolicitacaoCirurgiaImp()

  private materialOpmeDefault: any = {
    opmeId: '',
    quantidade: '',
    quantidadeMinima: '',
    quantidadeMaxima: '',
    procedimentoBilateral: {
      quantidadeMaxima: '',
    },
    medidaTamanho: '',
    gradeCompleta: false,
  }

  private gradeMedicaEventosDefault: GradeMedicaEvento[] = []

  public materiaisOpme: any[] = [{ ...this.materialOpmeDefault }]
  public gradeMedicaEventos: GradeMedicaEvento[] = [...this.gradeMedicaEventosDefault]
  public hospitalNome: string = ''

  documentosObrigatoriosOptions: IDocumentoObrigatorio[] = []

  /** Check needs use the default template or by assurance */
  get currentTemplate() {
    // Try get template by assurance
    const convenioId = this.solicitacaoCirurgia.paciente && this.solicitacaoCirurgia.paciente.convenioId
    if (convenioId) {
      if (this.template.porConvenios) {
        const templatePorConvenio = this.template.porConvenios.find((elem: any) => elem.convenioIds.includes(convenioId))
        if (templatePorConvenio) {
          return templatePorConvenio.template
        }
      }
    }

    // If not found by assurance, returns the default template
    return this.template
  }

  // #region Protocolo

  selectedProtocolo = {} as IProtocolo
  selectedProtocoloKitV2 = {} as IProtocoloKitDeOpmeV2Solicitacao

  protocoloOptions: IProtocolo[] = []

  canShowModalSugestaoDeProtocolo = false
  protocolRejectionModal = false

  get protocoloTecnicaDeCirurgiaOptions() {
    if (!this.selectedProtocolo.id || !this.segueOProtocolo) {
      return []
    }

    // Create avaliable tecnicas de cirurgia based on kits de opme
    const avaliableTecnicaDeCirurgiaOptions: IProtocoloTecnicaDeCirurgia[] = []
    this.selectedProtocolo!.kitsDeOpme.forEach((elem) => {
      if (elem.tecnicaDeCirurgia) {
        avaliableTecnicaDeCirurgiaOptions.push(elem.tecnicaDeCirurgia)
      }
    })

    return avaliableTecnicaDeCirurgiaOptions
  }

  get protocoloFornecedorOptions() {
    if (!this.selectedProtocolo.id || !this.segueOProtocolo) {
      return []
    }
    return this.selectedProtocolo!.fornecedores || []
  }

  get materialOptionsOpmes(): MaterialOptions[] {
    if (this.segueOProtocolo) {
      return this.opmesOpcionaisOptions
    }

    return this.solicitacaoMaterialOptions
  }

  get protocoloKitOpmesOptions() {
    if (!this.selectedProtocolo.id || !this.segueOProtocolo) {
      return []
    }

    if (!this.isRequiredChooseTecnicaDeCirurgia) {
      return this.selectedProtocolo.kitsDeOpme
    }

    if (this.solicitacaoCirurgia.protocoloDeCirurgia!.tecnicaDeCirurgiaId) {
      return this.selectedProtocolo.kitsDeOpme.filter((elem) => {
        // Fill tecnica de cirurgia nome when exists tecnica
        if (elem.tecnicaDeCirurgia) {
          const tecnicaDeCirurgia = this.protocoloTecnicaDeCirurgiaOptions.find(tecnicaOption => tecnicaOption.id === elem.tecnicaDeCirurgia.id)
          if (tecnicaDeCirurgia) {
            elem.tecnicaDeCirurgia.nome = tecnicaDeCirurgia.nome
          }
        }

        return !elem.tecnicaDeCirurgia
        || elem.tecnicaDeCirurgia.id === this.solicitacaoCirurgia.protocoloDeCirurgia!.tecnicaDeCirurgiaId
      })
    }

    return []
  }

  get protocoloKitOpmesV2Options() {
    if (!this.selectedProtocolo.id || !this.segueOProtocolo || !this.selectedProtocolo.kitsDeOpmeV2) {
      return []
    }

    if (!this.isRequiredChooseTecnicaDeCirurgia) {
      return this.selectedProtocolo.kitsDeOpmeV2
    }

    if (this.solicitacaoCirurgia.protocoloDeCirurgia!.tecnicaDeCirurgiaId && this.selectedProtocolo.kitsDeOpmeV2) {
      return this.selectedProtocolo.kitsDeOpmeV2.filter((elem) => {
        // Fill tecnica de cirurgia nome when exists tecnica
        if (elem.tecnicaDeCirurgia) {
          const tecnicaDeCirurgia = this.protocoloTecnicaDeCirurgiaOptions.find(tecnicaOption => tecnicaOption.id === elem.tecnicaDeCirurgia.id)
          if (tecnicaDeCirurgia) {
            elem.tecnicaDeCirurgia.nome = tecnicaDeCirurgia.nome
          }
        }

        return !elem.tecnicaDeCirurgia
        || elem.tecnicaDeCirurgia.id === this.solicitacaoCirurgia.protocoloDeCirurgia!.tecnicaDeCirurgiaId
      })
    }

    return []
  }

  get fornecedorOptions() {
    if (!this.selectedProtocolo.id || !this.segueOProtocolo) {
      return this.fornecedores
    }

    const fornecedores = this.selectedProtocolo!.fornecedores || []
    return fornecedores.map<Fornecedor>((elem) => {
      return {
        fornecedorId: elem.fornecedorId,
        nome: elem.fornecedorNome,
      } as Fornecedor
    })
  }

  get kitOpmeOptions() {
    if (!this.selectedProtocolo.id || !this.segueOProtocolo) {
      return this.medicoGrupoOpmes as GrupoOpme[]
    }

    return this.protocoloKitOpmesOptions.map<GrupoOpme>((kit) => {
      const opmes = kit.opmes.map((opme) => {
        return {
          opme: {
            id: opme.id,
            descricao: opme.descricao,
          },
          medicoPodeAlterarAQuantidade: opme.medicoPodeAlterarAQuantidade,
          quantidade: opme.quantidade,
          quantidadeMinima: opme.quantidadeMinima,
          quantidadeMaxima: opme.quantidadeMaxima,
          procedimentoBilateral: opme.procedimentoBilateral,
          fornecedores: opme.fornecedores,
          medidaTamanho: opme.medidaTamanho,
        }
      })

      return {
        id: kit.id,
        descricao: kit.nome,
        tecnicaDeCirurgia: kit.tecnicaDeCirurgia,
        opmes,
      } as any as GrupoOpme
    })
  }

  get kitOpmeV2Options() {
    if (!this.selectedProtocolo.id || !this.segueOProtocolo) {
      return []
    }

    return this.protocoloKitOpmesV2Options.map((kit) => {
      return {
        ...kit,
      }
    })
  }

  @Action({ commit: 'setProtocoloOptions' })
  async loadProtocoloOptions() {
    if (
      this.solicitacaoCirurgia.hospitalId
      && this.solicitacaoCirurgia.medicoSolicitanteId
      && this.solicitacaoCirurgia.procedimento && this.solicitacaoCirurgia.procedimento.codigo
      && this.solicitacaoCirurgia.paciente && this.solicitacaoCirurgia.paciente.convenioId
    ) {
      const { hospitalId, medicoSolicitanteId } = this.solicitacaoCirurgia
      const { codigo } = this.solicitacaoCirurgia.procedimento
      const { convenioId, planoId } = this.solicitacaoCirurgia.paciente

      const res = await ProtocoloApi.getProtocolosByCirurgia({
        hospitalId, medicoId: medicoSolicitanteId, codigoDoProcedimentoPrincipal: codigo, convenioId, planoId,
      })

      return res.data || []
    }

    return []
  }

  @Mutation
  setReservaSalaId(value: string) {
    this.reservaSalaId = value
  }

  @Mutation
  setAnestesistasHospital(value: AnestesistaHospital[]) {
    this.anestesistasHospital = value
  }

  @Mutation
  setProtocoloOptions(data: IProtocolo[]) {
    this.protocoloOptions = data
  }

  @Mutation
  async protocoloChange(canReset = true) {
    return new Promise<void>(async (resolve, rej) => {
      EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })

      // Clear kit v2 on protocolo change
      this.selectedProtocoloKitV2 = {} as IProtocoloKitDeOpmeV2Solicitacao

      // Set selected protocolo by id
      const selectedProtocoloId = this.solicitacaoCirurgia.protocoloDeCirurgia!.protocoloDeCirurgiaId

      let selectedProtocolo: IProtocolo | undefined
      if (selectedProtocoloId) {
        selectedProtocolo = (await ProtocoloApi.getProtocoloById({
          hospitalId: this.solicitacaoCirurgia.hospitalId, protocoloId: selectedProtocoloId,
        })).data
      }

      if (selectedProtocolo) {
        selectedProtocolo.kitsDeOpme = selectedProtocolo.kitsDeOpme || []
        selectedProtocolo.kitsDeOpmeV2 = selectedProtocolo.kitsDeOpmeV2 || []
        this.selectedProtocolo = selectedProtocolo

        if (selectedProtocolo.opmesOpcionais && selectedProtocolo.opmesOpcionais.opmes.length > 0) {
          this.opmesOpcionaisOptions = this.selectedProtocolo.opmesOpcionais!.opmes.map((opme) => {
            return {
              id: opme.id,
              descricao: opme.descricao,
              possuiGrade: false,
              disabled: false,
            }
          })

          this.opmesOpcionaisOptionsMaximumQuantity = this.selectedProtocolo.opmesOpcionais!.quantidadeMaxima
        }
      }

      // Clear selected técnica de cirurgia
      if (canReset) {
        this.solicitacaoCirurgia.protocoloDeCirurgia!.tecnicaDeCirurgiaId = undefined

        // Limpa os campos dependentes de tecnica de cirurgia
        this.solicitacaoCirurgia.protocoloDeCirurgia!.kitDeOpmeId = ''
        this.solicitacaoCirurgia.grupoDeOpme!.descricao = ''
        this.solicitacaoCirurgia.grupoDeOpme!.opmes.splice(0, this.solicitacaoCirurgia.grupoDeOpme!.opmes.length)

        if (selectedProtocolo) {
          solicitacaoStoreMiddleware.solicitacaoStore.setProcedimentoPrincipal(this.selectedProtocolo.procedimentoPrincipal as Procedimento)
          solicitacaoStoreMiddleware.solicitacaoStore.setProcedimentoAssociados(this.selectedProtocolo.procedimentosAssociados as Procedimento[])

          this.solicitacaoCirurgia.procedimento = this.selectedProtocolo.procedimentoPrincipal as Procedimento
          this.solicitacaoCirurgia.procedimentosAssociados = this.selectedProtocolo.procedimentosAssociados as Procedimento[]
        }
      }

      // Atualiza se pode editar algumas informações dos materiais de acordo com kit do protocolo escolhido
      if (
        this.selectedProtocolo
        && this.selectedProtocolo.kitsDeOpme
        && !this.selectedProtocolo.kitsDeOpmeV2
        && this.solicitacaoCirurgia.protocoloDeCirurgia!.kitDeOpmeId
      ) {
        const kitOpme = this.selectedProtocolo.kitsDeOpme.find(elem => elem.id === this.solicitacaoCirurgia.protocoloDeCirurgia!.kitDeOpmeId)
        if (kitOpme) {
          this.solicitacaoCirurgia.grupoDeOpme!.opmes.forEach((opmeSolicitacao) => {
            const opmeFromKit = kitOpme.opmes.find(opmeKit => opmeKit.id === opmeSolicitacao.id)
            if (opmeFromKit) {
              // eslint-disable-next-line no-param-reassign
              opmeSolicitacao.medicoPodeAlterarAQuantidade = opmeFromKit.medicoPodeAlterarAQuantidade
              opmeSolicitacao.quantidadeMinima = opmeFromKit.quantidadeMinima
              opmeSolicitacao.quantidadeMaxima = opmeFromKit.quantidadeMaxima
              opmeSolicitacao.procedimentoBilateral = opmeFromKit.procedimentoBilateral
              opmeSolicitacao.fornecedores = opmeFromKit.fornecedores
              opmeSolicitacao.medidaTamanho = opmeFromKit.medidaTamanho
            }
          })
        }
      }

      // Atualiza o selectedProtocoloKitV2 baseado nas informações dos materiais da solicitação
      if (this.selectedProtocolo
        && this.selectedProtocolo.kitsDeOpmeV2
        && this.solicitacaoCirurgia.protocoloDeCirurgia!.kitDeOpmeId
      ) {
        const kitOpme = this.selectedProtocolo.kitsDeOpmeV2.find(elem => elem.id === this.solicitacaoCirurgia.protocoloDeCirurgia!.kitDeOpmeId)
        if (kitOpme) {
          const kitOpmeCloned = JSON.parse(JSON.stringify(kitOpme)) as IProtocoloKitDeOpmeV2Solicitacao

          kitOpmeCloned.materiais.forEach((material) => {
            const selectedMaterialCodificado = material.materiaisCodificados.find((materialCodificado) => {
              const opmeSolicitacao = this.solicitacaoCirurgia.grupoDeOpme!.opmes.find(opme => opme.id === materialCodificado.id)
              if (opmeSolicitacao) {
                material.selectedFornecedorId = opmeSolicitacao.fornecedor1Id
                material.quantidade = opmeSolicitacao.quantidade
              }

              return !!opmeSolicitacao
            })

            material.selectedMaterialCodificado = selectedMaterialCodificado
          })

          this.selectedProtocoloKitV2 = kitOpmeCloned

          // Cria os materiais por grupo do kit do protocolo v2
          if (
            this.selectedProtocoloKitV2.materiais
          ) {
            const materialsMap = new Map<string, IProtocoloMaterialDoKitV2Solicitacao[]>()

            this.selectedProtocoloKitV2.materiais.forEach((elem) => {
              const materialGroup = elem.grupoDeMaterial || ''
              const materials = materialsMap.get(materialGroup) || []

              if (materials.length === 0) {
                materialsMap.set(materialGroup, materials)
              }

              materials.push(elem)
            })

            const materiaisPorGrupo: IProtocoloMateriaisPorGrupoV2Solicitacao[] = []

            materialsMap.forEach((materiais, key) => {
              let group: IProtocoloMaterialAgrupado | undefined
              if (this.selectedProtocoloKitV2.materiaisAgrupados) {
                group = this.selectedProtocoloKitV2.materiaisAgrupados.find(elem => elem.id === key)
              }

              if (group) {
                materiaisPorGrupo.push({
                  ...group,
                  materiais,
                })
              } else {
                materiaisPorGrupo.push({
                  materiais,
                } as IProtocoloMateriaisPorGrupoV2Solicitacao)
              }
            })

            this.selectedProtocoloKitV2.materiaisPorGrupo = materiaisPorGrupo
          }
        }
      }

      EventBus.$emit('clearLoadingRequest')

      resolve()
    })
  }

  @Mutation
  tecnicaDeCirurgiaChange() {
    // Limpa os campos dependentes de tecnica de cirurgia
    this.solicitacaoCirurgia.protocoloDeCirurgia!.kitDeOpmeId = ''
    this.solicitacaoCirurgia.grupoDeOpme!.descricao = ''
    this.solicitacaoCirurgia.grupoDeOpme!.opmes.splice(0, this.solicitacaoCirurgia.grupoDeOpme!.opmes.length)
  }

  // Verifica se a cirurgia tem protocolo e não foi respondido nada
  // Trata exatamente dos casos em que uma cirurgia foi criada a partir de um modelo de cirurgia
  @Action
  async checkExistProtocoloParaOProcedimentoAoCarregarSolicitacao() {
    // Se a página for detalhes da cirurgia ou orçamento avulso por exemplo, não deve sugerir protocolo
    if (!this.canSuggestProtocol) {
      return
    }

    if (this.protocoloOptions.length > 0) {
      if (
        this.solicitacaoCirurgia.procedimento!.id
        && !this.solicitacaoCirurgia.protocoloDeCirurgia!.protocoloDeCirurgiaId
        && !this.solicitacaoCirurgia.protocoloDeCirurgia!.medicoRecusouSeguirOProtocolo
      ) {
        // Se tiver apenas uma opção, já preenche o select
        if (this.protocoloOptions.length === 1) {
          this.solicitacaoCirurgia.protocoloDeCirurgia!.protocoloDeCirurgiaId = this.protocoloOptions[0].id
        }

        this.setShowModalSugestaoDeProtocolo(true)
      }
    }
  }

  @Action
  async checkExistProtocoloParaOProcedimento(data: Procedimento): Promise<boolean> {
    // Se a página for detalhes da cirurgia ou orçamento avulso por exemplo, não deve sugerir protocolo
    if (!this.canSuggestProtocol) {
      return false
    }

    let exists = false

    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })

    this.solicitacaoCirurgia.procedimento = data
    await this.context.dispatch('loadProtocoloOptions')

    if (this.protocoloOptions.length > 0) {
      // Se tiver apenas uma opção, já preenche o select
      if (this.protocoloOptions.length === 1) {
        this.solicitacaoCirurgia.protocoloDeCirurgia!.protocoloDeCirurgiaId = this.protocoloOptions[0].id
      }

      this.setShowModalSugestaoDeProtocolo(true)
      exists = true
    } else {
      if (this.solicitacaoCirurgia.protocoloDeCirurgia!.protocoloDeCirurgiaId) {
        this.context.commit('clearProtocolo')

        const message = 'Protocolo de cirurgia foi removido pois ao editar o procedimento principal, você deixou de seguir o protocolo.'
        EventBus.$emit('setSnackbar', { show: true, text: `${message}`, icon: 'done', color: '#03a5ed', timeout: 10000 })
      }

      this.context.commit('clearProtocolo')
    }

    EventBus.$emit('clearLoadingRequest')

    return exists
  }

  @Action
  async checkSelectedProtocoloExistsOnModelosCirurgia() {
    // Se a nova lista de modelos de cirurgia não contém nenhum protocolo, limpa o protocolo
    if (!this.modelosCirurgia.some(elem => elem.tipo === 'Protocolo')) {
      if (
        this.solicitacaoCirurgia.protocoloDeCirurgia!.medicoRecusouSeguirOProtocolo === true
        || this.solicitacaoCirurgia.protocoloDeCirurgia!.protocoloDeCirurgiaId
      ) {
        const message = 'Protocolo de cirurgia foi removido pois o convênio selecionado não possui programa de protocolo.'
        EventBus.$emit('setSnackbar', { show: true, text: `${message}`, icon: 'done', color: '#03a5ed', timeout: 10000 })
      }

      this.context.commit('clearProtocolo')

      return
    }

    // Se não existir procedimento selecionado, não é possível sugerir um protocolo
    if (!this.solicitacaoCirurgia.procedimento!.id) {
      return
    }

    // Se o médico recusou seguir o protocolo ou não tem protocolo, limpa e sugere um protocolo novo
    if (
      this.solicitacaoCirurgia.protocoloDeCirurgia!.medicoRecusouSeguirOProtocolo === true
      || !this.solicitacaoCirurgia.protocoloDeCirurgia!.protocoloDeCirurgiaId
    ) {
      this.context.commit('clearProtocolo')
      this.checkExistProtocoloParaOProcedimento(this.solicitacaoCirurgia.procedimento!)
      return
    }

    // Se tiver protocolo selecionado e não estiver na lista de modelos de cirurgia, limpa o protocolo e sugere a seleção de um novo
    if (this.solicitacaoCirurgia.protocoloDeCirurgia!.protocoloDeCirurgiaId) {
      const modeloIndex = this.modelosCirurgia.findIndex(modelo => modelo.id === this.selectedProtocolo.id)
      if (modeloIndex === -1) {
        const message = 'Protocolo de cirurgia foi removido pois o convênio selecionado não possui o protocolo escolhido anteriormente.'
        EventBus.$emit('setSnackbar', { show: true, text: `${message}`, icon: 'done', color: '#03a5ed', timeout: 10000 })

        this.context.commit('clearProtocolo')
        this.checkExistProtocoloParaOProcedimento(this.solicitacaoCirurgia.procedimento!)
      }
    }
  }

  @Action
  acceptSugestaoDeProtocolo() {
    this.solicitacaoCirurgia.protocoloDeCirurgia!.segueOProtocolo = StatusDoProtocoloEnum.segueOProtocolo
    this.solicitacaoCirurgia.protocoloDeCirurgia!.medicoRecusouSeguirOProtocolo = false

    this.context.commit('protocoloChange')
    this.context.dispatch('addProcedimentoQuantidade', this.solicitacaoCirurgia.procedimento)
  }

  @Action
  rejectSugestaoDeProtocolo() {
    this.solicitacaoCirurgia.protocoloDeCirurgia!.segueOProtocolo = StatusDoProtocoloEnum.naoSegueOProtocolo
    this.solicitacaoCirurgia.protocoloDeCirurgia!.medicoRecusouSeguirOProtocolo = true
    this.solicitacaoCirurgia.protocoloDeCirurgia!.protocoloDeCirurgiaId = ''
    this.context.dispatch('addProcedimentoQuantidade', this.solicitacaoCirurgia.procedimento)
  }

  @Mutation
  setShowModalSugestaoDeProtocolo(value: boolean) {
    this.canShowModalSugestaoDeProtocolo = value
  }

  @Mutation
  showProtocolRejectionModal(value: boolean) {
    this.protocolRejectionModal = value
  }

  @Action({ rawError: true })
  materialChange(data: { opme: OpmeMaterial, index: number }) {
    const { opme, index } = data
    this.solicitacaoCirurgia.grupoDeOpme!.opmes[index].id = opme.id
    this.solicitacaoCirurgia.grupoDeOpme!.opmes[index].descricao = opme.descricao

    const optionalOpme = this.selectedProtocolo.opmesOpcionais ? this.selectedProtocolo.opmesOpcionais!.opmes.find(item => item.id === opme.id) : null

    if (optionalOpme) {
      this.solicitacaoCirurgia.grupoDeOpme!.opmes[index].medicoPodeAlterarAQuantidade = optionalOpme.medicoPodeAlterarAQuantidade
      this.solicitacaoCirurgia.grupoDeOpme!.opmes[index].quantidade = optionalOpme.quantidade
      this.solicitacaoCirurgia.grupoDeOpme!.opmes[index].tipo = 'OpmeOpcionalDoProtocolo'
    }

    this.context.commit('updateSolicitacaoMaterialOptions')
  }

  @Mutation
  fornecedorChange(data: { fornecedorId: string, fieldName: string }) {
    const { fornecedorId, fieldName } = data
    this.solicitacaoCirurgia.grupoDeOpme!.opmes.forEach((opme) => {
      if (!opme[fieldName]) {
        // Verifica antes de preencher de forma automática, se tem fornecedores no opme
        // Se tiver verifica se aquele fornecedor Id existe nos opmes
        // Essa regra é necessária pois para protocolo os materiais podem ter fornecedores diferentes
        if (opme.fornecedores && opme.fornecedores.length > 0) {
          if (opme.fornecedores.find(elem => elem.fornecedorId === fornecedorId)) {
            opme[fieldName] = fornecedorId
          }
        } else {
          opme[fieldName] = fornecedorId
        }
      }
    })
  }

  @Mutation
  fornecedorV2Change(data: IProtocoloMaterialDoKitV2) {
    const fornecedorId = data.selectedFornecedorId

    // Replica o fornecedor selecionado em um material para todo os outros que não tenham fornecedor
    this.selectedProtocoloKitV2.materiais.forEach((material) => {
      if (
        !material.selectedFornecedorId
        && material.fornecedores.find(elem => elem.fornecedorId === fornecedorId)
      ) {
        material.selectedFornecedorId = fornecedorId
      }
    })
  }

  @Mutation
  updateSolicitacaoMaterialOptions() {
    const segueOProtocolo = this.solicitacaoCirurgia.protocoloDeCirurgia!.segueOProtocolo === StatusDoProtocoloEnum.segueOProtocolo

    if (segueOProtocolo) {
      this.opmesOpcionaisOptions.forEach((opme) => {
        const findIndex = this.solicitacaoCirurgia.grupoDeOpme!.opmes.findIndex(elem => elem.id === opme.id)
        if (findIndex !== -1) {
          // eslint-disable-next-line
          opme.disabled = true
        } else {
          // eslint-disable-next-line
          opme.disabled = false
        }
      })
    } else {
      this.solicitacaoMaterialOptions.forEach((opme) => {
        const findIndex = this.solicitacaoCirurgia.grupoDeOpme!.opmes.findIndex(elem => elem.id === opme.id)
        if (findIndex !== -1) {
          // eslint-disable-next-line
          opme.disabled = true
        } else {
          // eslint-disable-next-line
          opme.disabled = false
        }
      })
    }
  }

  @Action
  checkNeedRejectOrRemoveProtocoloByProcedimentoPrincipalChange() {
    if (this.solicitacaoCirurgia.protocoloDeCirurgia!.medicoRecusouSeguirOProtocolo) {
      this.context.commit('clearProtocolo')
      return
    }

    if (this.solicitacaoCirurgia.protocoloDeCirurgia!.protocoloDeCirurgiaId) {
      this.context.commit('clearProtocolo')

      const message = 'Protocolo de cirurgia foi removido pois ao editar o procedimento principal, você deixou de seguir o protocolo.'
      EventBus.$emit('setSnackbar', { show: true, text: `${message}`, icon: 'done', color: '#03a5ed', timeout: 10000 })
    }
  }

  @Action
  checkNeedRejectOrRemoveProtocoloByProcedimentoAssociadoChange() {
    // Regra desativada por enquanto a pedido da Amil
    // Poderá ser reativada caso seja criada uma regra a parte
    // Não remover o código por hora
    // if (
    //   this.solicitacaoCirurgia.protocoloDeCirurgia!.protocoloDeCirurgiaId
    //   && !this.solicitacaoCirurgia.protocoloDeCirurgia!.medicoRecusouSeguirOProtocolo
    // ) {
    //   // Rejeita o protocolo
    //   this.solicitacaoCirurgia.protocoloDeCirurgia!.segueOProtocolo = StatusDoProtocoloEnum.naoSegueOProtocolo
    //   this.solicitacaoCirurgia.protocoloDeCirurgia!.medicoRecusouSeguirOProtocolo = true
    //   this.solicitacaoCirurgia.protocoloDeCirurgia!.protocoloDeCirurgiaId = ''

    //   const message = 'Ao editar um procedimento associado você deixou de seguir o protocolo.'
    //   EventBus.$emit('setSnackbar', { show: true, text: `${message}`, icon: 'done', color: '#03a5ed', timeout: 10000 })

    //   if (this.currentTemplate.formulario) {
    //     const formTemplateProtocolJustification = this.currentTemplate.formulario.justificativaDoProtocolo

    //     if (formTemplateProtocolJustification && formTemplateProtocolJustification.habilitado) {
    //       this.showProtocolRejectionModal(true)
    //     }
    //   }
    // }
  }

  @Action
  async rejectFidelizationProtocolSuggestion({ id, payload }: { id: string, payload: IProtocoloJustificativaDoMedico }) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.rejectFidelizationProtocolSuggestion(id, payload)
    return request
  }

  @Action
  protocoloKitDeOpmeV2Change() {
    const opmes = this.selectedProtocoloKitV2.materiais.filter(elem => elem.selectedMaterialCodificado).map((material) => {
      const {
        nomeTecnico, quantidade, quantidadeMinima, quantidadeMaxima, medicoPodeAlterarAQuantidade, fornecedores,
        gradeCompleta, observacao,
      } = material

      const id = material.selectedMaterialCodificado!.id!
      const fornecedor1Id = material.selectedFornecedorId

      return {
        id,
        descricao: nomeTecnico,
        quantidade,
        quantidadeMinima,
        quantidadeMaxima,
        // procedimentoBilateral?: {
        //   quantidadeMaxima: number,
        // },
        fornecedores,
        gradeCompleta,
        observacao,
        fornecedor1Id,
        medicoPodeAlterarAQuantidade,
        tipo: 'OpmeDoKitDoProtocolo' as any,
      }
    })

    this.solicitacaoCirurgia.grupoDeOpme = {
      descricao: this.selectedProtocoloKitV2.nome,
      opmes,
    }
  }

  // #endregion Protocolo

  @Action({ commit: 'setDocumentosObrigatoriosOptions' })
  async loadDocumentosObrigatorios() {
    const { hospitalId } = this.solicitacaoCirurgia
    const convenioId = this.solicitacaoCirurgia.paciente && this.solicitacaoCirurgia.paciente.convenioId

    const procedimentoPrincipal = solicitacaoStoreMiddleware.solicitacaoStore.solicitacao.procedimento
    && solicitacaoStoreMiddleware.solicitacaoStore.solicitacao.procedimento.codigo

    const procedimentosAssociados = solicitacaoStoreMiddleware
      .solicitacaoStore
      .solicitacao
      .procedimentosAssociados!.map(elem => elem.codigo) as string[]

    if (procedimentoPrincipal && hospitalId && convenioId) {
      const procedimentos: string[] = [procedimentoPrincipal, ...procedimentosAssociados]
      const res = await AgendamentoApi.getDocumentosObrigatoriosParaSolicitacao(procedimentos, hospitalId, convenioId)

      if (res.success) {
        return res.data || []
      }
    }

    return []
  }

  @Mutation
  setDocumentosObrigatoriosOptions(data: IDocumentoObrigatorio[]) {
    this.documentosObrigatoriosOptions = data
  }

  @Mutation
  setSurgerySolicitationActions(actions: Acoes) {
    this.surgerySolicitationActions = actions
  }

  // Deleta grupo opme dos grupos do salvos do médico
  @Action
  async deleteGrupoOpme(grupoOpmeId: string) {
    const { hospitalId, medicoSolicitanteId } = this.solicitacaoCirurgia

    const res = await this.solicitacaoCirurgiaImp.deleteMedicoGrupoOpme(hospitalId, medicoSolicitanteId, grupoOpmeId)
    if (res.success) {
      const kitIndex = this.kitOpmeOptions.findIndex(elem => elem.id === grupoOpmeId)
      if (kitIndex !== -1) {
        this.kitOpmeOptions.splice(kitIndex, 1)
      }
    }

    return res
  }

  @Action
  async getHealthInsuranceById({ hospitalId, healthInsuranceId }): Promise<any> {
    try {
      const healthInsuranceAPIRequest = await SolicitacaoCirurgiaApi.getConvenioById({ hospitalId, convenioId: healthInsuranceId })
      return healthInsuranceAPIRequest.success
        ? healthInsuranceAPIRequest.data
        : { prazoEmDiasParaSolicitarCirurgiaComOpme: null, prazoEmDiasParaSolicitarCirurgiaSemOpme: null }
    } catch (error) {
      return { prazoEmDiasParaSolicitarCirurgiaComOpme: null, prazoEmDiasParaSolicitarCirurgiaSemOpme: null }
    }
  }

  @Action
  async addProcedimentoQuantidade(procedimento: Procedimento) {
    // eslint-disable-next-line
    procedimento.quantidade = 1
    solicitacaoStoreMiddleware.solicitacaoStore.setProcedimentoQuantidade(procedimento)
    await solicitacaoStoreMiddleware.solicitacaoStore.showModalProcedimentoQuantidade(true)
  }

  @Mutation
  setModal(modal: any) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  resetPaciente() {
    this.solicitacaoCirurgia.paciente = { ...this.pacienteDefault }
  }

  @Mutation
  resetPacienteMantendoRGH() {
    this.pacienteDefault.rgh = this.solicitacaoCirurgia.paciente!.rgh
    this.solicitacaoCirurgia.paciente = { ...this.pacienteDefault }
  }

  @Mutation
  resetPacienteDocumentacaoObrigatoria() {
    this.solicitacaoCirurgia.paciente.rne = null
    this.solicitacaoCirurgia.paciente.passaporte = null
    this.solicitacaoCirurgia.paciente.paisId = null
    this.solicitacaoCirurgia.paciente.cpfResponsavel = ''
    this.solicitacaoCirurgia.paciente.certidaoNascimentoLivro = ''
    this.solicitacaoCirurgia.paciente.certidaoNascimentoFolha = ''
    this.solicitacaoCirurgia.paciente.certidaoNascimentoTermo = ''
  }

  @Mutation
  clearTempoDeDoenca() {
    this.solicitacaoCirurgia.tempoDeDoenca = { ...this.tempoDeDoencaDefault }
  }

  @Mutation
  setHospitalNome(value: string) {
    this.hospitalNome = value
  }

  @Mutation
  setPacientesLista(value: Paciente[]) {
    this.pacientesLista = value
  }

  @Mutation
  clearPacientesLista() {
    this.pacientesLista = [...this.pacientesListaDefault]
  }

  @Mutation
  setCarater(value: string) {
    this.solicitacaoCirurgia.carater = value
  }

  @Mutation
  setOpmeGrupoId(value: string) {
    this.opmeGrupoId = value
  }

  @Mutation
  clearOpmeGrupoId() {
    this.opmeGrupoId = ''
  }

  @Mutation
  clearOpmeGrupoInicial() {
    this.opmeGrupoInicial = []
  }

  @Mutation
  adicionarItemOPME() {
    this.opmeGrupo.push({ ...this.opmeDefault })
    this.fornecedores.map((e: any) => {
      const c = e
      c.disabled = false
      return c
    })
  }

  @Mutation
  removeItemOPME(index: number) {
    if (this.opmeGrupo.length === 1) return
    const opmeId = this.opmeGrupo[index].opme ? this.opmeGrupo[index].opme.id : ''
    const opme = this.listaMedicoOpme.find((e: any) => e.id === opmeId)
    if (opme) opme.disabled = false
    this.opmeGrupo.splice(index, 1)
  }

  @Mutation
  resetOPMEGrupo() {
    this.opmeGrupo = [...this.opmeGrupoDefault]
  }

  @Mutation
  opmeDisabledChange() {
    this.listaMedicoOpme.map((e: any) => {
      const opme = e
      opme.disabled = this.opmeGrupo.some(op => op.opme.id === e.id)
      return opme
    })
  }

  @Mutation
  clearOpmeFornecedorIndex() {
    this.opmeFornecedorIndex = null
  }

  @Mutation
  setOpmeFornecedorIndex(payload: { id: string, index: number }) {
    this.opmeFornecedorIndex = payload.index
    if (payload.id) {
      this.context.commit('fornecedorDisabledChange', payload)
    } else {
      this.fornecedores.map((e: any) => {
        const r = e
        r.disabled = false
        return r
      })
    }
  }

  @Mutation
  fornecedorDisabledChange(opmeFornecedor: any) {
    this.fornecedores.map((e: any) => {
      const r = e
      r.disabled = (r.fornecedorId === this.opmeGrupo[opmeFornecedor.index].fornecedor1Id
        || r.fornecedorId === this.opmeGrupo[opmeFornecedor.index].fornecedor2Id
        || r.fornecedorId === this.opmeGrupo[opmeFornecedor.index].fornecedor3Id)
      if (r.disabled) {
        r.disabled = opmeFornecedor.index === this.opmeFornecedorIndex
      }

      return r
    })
  }

  @Mutation
  enableOPMEs(opmeEdit: any) {
    const ids = opmeEdit.opmes.map((e: any) => {
      const { id } = e.opme
      return id
    })

    this.listaMedicoOpme.map((e: any) => {
      const opme = e
      opme.disabled = ids.includes(opme.id)
      return opme
    })
  }

  @Mutation
  enableFornecedores() {
    this.fornecedores.map((e: any) => {
      const f = e
      f.disabled = false
      return f
    })
  }

  @Mutation
  setOpmeGrupo(value: any) {
    const opmes = value.opmes.map((e: any) => ({
      opme: e.opme,
      quantidade: e.quantidade,
      quantidadeMaxima: e.quantidadeMaxima,
      quantidadeMinima: e.quantidadeMinima,
      procedimentoBilateral: e.procedimentoBilateral,
      possuiGrade: e.opme.possuiGrade,
      observacao: e.observacao,
      fornecedor1Id: e.fornecedor1Id,
      fornecedor2Id: e.fornecedor2Id,
      fornecedor3Id: e.fornecedor3Id,
      medidaTamanho: e.medidaTamanho,
    }))

    this.opmeGrupo = opmes
    this.opmeGrupoInicial = setOPMEsToSave(opmes)
  }

  @Mutation
  setDataCirurgiaDataCirurgia(value: any) {
    this.dataCirurgia.dataCirurgia = value
  }

  @Mutation
  setDataCirurgiaHora(value: any) {
    this.dataCirurgia.hora = value
  }

  @Mutation
  clearDataCirurgia() {
    this.dataCirurgia = { ...this.dataCirurgiaDefault }
  }

  @Mutation
  setOpcaoDataPrevisto1(value: string | Date | null) {
    this.solicitacaoCirurgia.opcaoDataPrevisto1 = value
  }

  @Mutation
  adicionarOpmeDefault() {
    const opme: GrupoOpmes = {
      gradeCompleta: false,
      opme: {
        descricao: '',
        id: '',
        possuiGrade: false,
      },
      opmeId: '',
      quantidade: 0,
      quantidadeMaxima: 0,
      quantidadeMinima: 0,
      procedimentoBilateral: {
        quantidadeMaxima: 0,
      },
      medidaTamanho: '',
      fornecedores: [],
    }

    this.grupoOpme.opmes.push(opme)
  }

  @Mutation
  setListaMedicoOpme(value: any[]) {
    this.listaMedicoOpme = value
    this.solicitacaoMaterialOptions = value.map(opme => ({ ...opme }))
  }

  @Mutation
  clearListaMedicoOpme() {
    this.listaMedicoOpme.splice(0, this.listaMedicoOpme.length)
  }

  @Mutation
  adicionarCamposDefault() {
    this.materiaisOpme.push({ ...this.materialOpmeDefault })
  }

  @Mutation
  setHabilitarGrade(value: boolean) {
    this.habilitarGrade = value
  }

  @Mutation
  setGrupoOpmes(value: any[]) {
    this.grupoOpme.opmes = value
  }

  @Mutation
  setGrupoOpme(value: any) {
    this.grupoOpme = value
  }

  @Mutation
  deleteOpmes(index: number) {
    this.grupoOpme.opmes.splice(index, 1)
  }

  @Mutation
  setModelosCirurgia(data: ModeloCirurgia[]) {
    data.unshift({ id: '', nomeCirurgia: 'Nova Cirurgia', tipo: '' })
    this.modelosCirurgia = data
  }

  @Mutation
  setExamesIntraOperatoriosCheckbox(value: string[]) {
    this.examesIntraOperatoriosCheckbox = value
  }

  @Mutation
  setHemocomponentesCheckbox(value: string[]) {
    this.hemocomponentesCheckbox = value
  }

  @Mutation
  setComorbidadesDoPacienteCheckbox(value: string[]) {
    this.comorbidadesDoPacienteCheckbox = value
  }

  @Mutation
  setPesoDoPaciente(value: string | null) {
    this.solicitacaoCirurgia.paciente.peso = value
  }

  @Mutation
  setAlturaDoPaciente(value: number | null) {
    this.solicitacaoCirurgia.paciente.altura = value
  }

  @Mutation
  setTipoAnestesiaCheckbox(value: string[]) {
    this.tipoAnestesiaCheckbox = value
  }

  @Mutation
  setInstrumentos(value: any[]) {
    this.instrumentos = value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
    this.solicitacaoCirurgia.hospitalId = value
  }

  @Mutation
  setMedicoSolicitanteId(value: string) {
    this.medicoSolicitanteId = value
    this.solicitacaoCirurgia.medicoSolicitanteId = value
  }

  @Mutation
  setShowModalOPME(value: boolean) {
    this.modal.opme = value
  }

  @Mutation
  setShowModalBuscarPaciente(value: boolean) {
    this.modal.buscarPaciente = value
  }

  @Mutation
  setShowModalCadastrarMaterial(value: boolean) {
    this.modal.cadastrarMaterial = value
  }

  @Mutation
  setShowModalCadastrarFornecedor(value: boolean) {
    this.modal.cadastrarFornecedor = value
  }

  @Mutation
  clearNovoFornecedor() {
    this.novoFornecedor = { ...this.novoFornecedorDefault }
  }

  @Mutation
  setShowModalDataCirurgia(value: boolean) {
    this.modal.dataCirurgia = value
  }

  @Mutation
  setStep(value: number) {
    this.step = value
  }

  @Mutation
  setFirstStep(value: boolean) {
    this.firstStep = value
  }

  @Mutation
  setIdade(value: number | null) {
    this.solicitacaoCirurgia.paciente.idade = value
  }

  @Mutation
  setConvenios(value: Convenio[]) {
    this.convenios = value
  }

  @Mutation
  setConveniosAssociados(value: Convenio[]) {
    this.conveniosAssociados = value
  }

  @Mutation
  setCentroCirurgico(value: CentroCirurgico[]) {
    this.centroCirurgico = value
  }

  @Mutation
  setPlanos(value: Plano[]) {
    this.planos = value
  }

  @Mutation
  setPlanosAssociados(value: Plano[]) {
    this.planosAssociados = value
  }

  @Mutation
  clearPlanos() {
    this.planos = []
  }

  @Mutation
  clearPlanosAssociados() {
    this.planosAssociados = []
  }

  @Mutation
  setCategorias(value: any[]) {
    this.categorias = value
  }

  @Mutation
  setCategoriasAssociadas(value: any[]) {
    this.categoriasAssociadas = value
  }

  @Mutation
  clearCategorias() {
    this.categorias = [...this.categoriasDefault]
  }

  @Mutation
  clearCategoriasAssociadas() {
    this.categoriasAssociadas = [...this.categoriasDefault]
  }

  @Mutation
  setTipoAcomodacao(value: any) {
    this.solicitacaoCirurgia.tipoAcomodacao = value
  }

  @Mutation
  setPlano(value: string) {
    this.solicitacaoCirurgia.paciente.planoId = value
  }

  @Mutation
  setPlanoAssociado(value: any) {
    this.solicitacaoCirurgia.planoAssociadoId = value
  }

  @Mutation
  setCategoria(value: string) {
    this.solicitacaoCirurgia.paciente.categoriaId = value
  }

  @Mutation
  setCategoriaAssociada(value: any) {
    this.solicitacaoCirurgia.categoriaAssociadaId = value
  }

  @Mutation
  setLaudos(value: Laudo[]): void {
    this.laudos = value
  }

  @Mutation
  setLaudosPaciente(values: Laudo[]): void {
    this.laudosPaciente = values
  }

  @Mutation
  setLaudosDiversos(values: Laudo[]): void {
    this.laudosDiversos = values
  }

  @Mutation
  setLaudosTermoDeConsentimento(values: Laudo[]): void {
    this.laudosTermoDeConsentimento = values
  }

  @Mutation
  setLaudosOrcamentoDeCirurgiaParticularAprovado(values: Laudo[]): void {
    this.laudosOrcamentoDeCirurgiaParticularAprovado = values
  }

  @Mutation
  clearLaudos() {
    this.laudos = []
  }

  @Mutation
  clearLaudosPaciente() {
    this.laudosPaciente = []
  }

  @Mutation
  clearLaudosDiversos() {
    this.laudosDiversos = []
  }

  @Mutation
  clearLaudosTermoDeConsentimento() {
    this.laudosTermoDeConsentimento = []
  }

  @Mutation
  clearOrcamentoDeCirurgiaParticularAprovado() {
    this.laudosOrcamentoDeCirurgiaParticularAprovado = []
  }

  @Mutation
  clearConvenios() {
    this.convenios = []
  }

  @Mutation
  clearConveniosAssociados() {
    this.conveniosAssociados = []
  }

  @Mutation
  setConvenio(value: string) {
    this.solicitacaoCirurgia.paciente.convenioId = value
  }

  @Mutation
  setConvenioAssociado(value: any) {
    this.solicitacaoCirurgia.convenioAssociadoId = value
  }

  @Mutation
  setModeloCirurgia(value: string) {
    this.solicitacaoCirurgia.modeloCirurgiaId = value
  }

  @Mutation
  clearModelosCirurgia() {
    this.modelosCirurgia = [{ id: '', nomeCirurgia: 'Nova Cirurgia', tipo: '' }]
  }

  @Mutation
  setLocaisAtendimento(value: LocalAtendimento[]) {
    this.locaisAtendimento = value
  }

  @Mutation
  clearLocaisAtendimento() {
    this.locaisAtendimento = []
  }

  @Mutation
  clearCodigoPrestador() {
    this.solicitacaoCirurgia.codigoPrestador = ''
  }

  @Mutation
  clearHonorarioMedicoDocumento() {
    this.solicitacaoCirurgia.honorarioMedicoDocumento = null
  }

  @Mutation
  clearHonorarioAnestesistaDocumento() {
    this.solicitacaoCirurgia.honorarioAnestesistaDocumento = null
  }

  @Mutation
  clearMedicoConvidado() {
    this.solicitacaoCirurgia.solicitacaoMedicoConvidado.celular = ''
    this.solicitacaoCirurgia.solicitacaoMedicoConvidado.medicoConvidado = ''
    this.solicitacaoCirurgia.solicitacaoMedicoConvidado.codigoConselho = ''
    this.solicitacaoCirurgia.solicitacaoMedicoConvidado.nome = ''
  }

  @Action
  clearAnestesiaDoHospital() {
    this.solicitacaoCirurgia.nomeAnestesista = ''
    this.solicitacaoCirurgia.anestesistaCrm = ''
    this.solicitacaoCirurgia.anestesista = null
    this.context.commit('clearTipoAnestesia')
  }

  @Mutation
  clearTipoAnestesia() {
    this.tipoAnestesiaCheckbox = []
  }

  @Mutation
  clearOutrosTipoAnestesia() {
    this.outrosTipoAnestesia = null
  }

  @Mutation
  clearCpf() {
    this.solicitacaoCirurgia.paciente.cpf = ''
  }

  @Mutation
  clearDiaria() {
    this.solicitacaoCirurgia.diaria = null
  }

  @Mutation
  clearDiariaUti() {
    this.solicitacaoCirurgia.diariaUti = null
  }

  @Mutation
  setGetSolicitacaoCirurgia(solicitacaoCirurgia: SolicitacaoCirurgia) {
    Object.entries(solicitacaoCirurgia).forEach(([key, value]) => {
      const fieldKey: any = key
      switch (fieldKey) {
        case 'reservaHemocomponentes':
          Object.entries(value).forEach(([key1, value1]) => {
            this.solicitacaoCirurgia.reservaHemocomponentes[key1].quantidade = key1
            this.solicitacaoCirurgia.reservaHemocomponentes[key1].value = key1
          })
          break

        case 'paciente':
          Object.entries(value).forEach(([key1, value1]) => {
            if (key1.includes('dataNascimento')) {
              const t: any = value1
              this.solicitacaoCirurgia.paciente[key1] = moment(t).format('YYYY-MM-DD')
            } else if (key1.includes('celular')) {
              const t: any = value1
              this.solicitacaoCirurgia.paciente[key1] = flatPhone(t)
            } else if (key1.includes('telefone')) {
              const t: any = value1
              this.solicitacaoCirurgia.paciente[key1] = flatPhone(t)
            } else {
              this.solicitacaoCirurgia.paciente[key1] = value1
            }
          })

          break

        case 'opcaoDataPrevisto1':
          this.solicitacaoCirurgia[key] = this.template.formulario.opcaoDataPrevisto1.gradeMedica ? moment(value).format('YYYY-MM-DDTHH:mm') : new Date(moment(value, 'YYYY-MM-DDTHH:mm').toString())
          break

        case 'opcaoDataPrevisto2':
        case 'opcaoDataPrevisto3':
          this.solicitacaoCirurgia[key] = new Date(moment(value, 'YYYY-MM-DDTHH:mm').toString())
          break

        case 'examesIntraOperatorios':
          Object.entries(value).forEach(([key1, value1]) => {
            if (key1.includes('ultrassonografiaIntraoperatoriaEquipeDoHospital')) this.solicitacaoCirurgia.examesIntraOperatorios[key1] = value1
            if (key1.includes('outrosEspecificar')) this.solicitacaoCirurgia.examesIntraOperatorios[key1] = value1
            if (key1.includes('anatomiaPatologicaHospitalOuParticular')) this.solicitacaoCirurgia.examesIntraOperatorios[key1] = value1
            if (key1.includes('anatomiaPatologicaParticularLocal')) this.solicitacaoCirurgia.examesIntraOperatorios[key1] = value1
            if (key1.includes('biopsiaHospitalOuParticular')) this.solicitacaoCirurgia.examesIntraOperatorios[key1] = value1
            if (key1.includes('biopsiaParticularLocal')) this.solicitacaoCirurgia.examesIntraOperatorios[key1] = value1
            if (value1) this.examesIntraOperatoriosCheckbox.push(key1)
          })

          break

        case 'solicitacaoMedicoConvidado':
          if (solicitacaoCirurgia.solicitacaoMedicoConvidado && solicitacaoCirurgia.solicitacaoMedicoConvidado.nome) {
            this.solicitacaoCirurgia.solicitacaoMedicoConvidado = {
              celular: solicitacaoCirurgia.solicitacaoMedicoConvidado.celular,
              codigoConselho: solicitacaoCirurgia.solicitacaoMedicoConvidado.codigoConselho,
              medicoConvidado: 'Sim',
              nome: solicitacaoCirurgia.solicitacaoMedicoConvidado.nome,
            }
          } else {
            this.solicitacaoCirurgia.solicitacaoMedicoConvidado.medicoConvidado = 'Nao'
          }

          break

        case 'alergiaLatex':
          if (solicitacaoCirurgia[key] === 0) {
            this.solicitacaoCirurgia.alergiaLatex = 'Nao'
          } else if (solicitacaoCirurgia[key] === 1) {
            this.solicitacaoCirurgia.alergiaLatex = 'Sim'
          } else {
            this.solicitacaoCirurgia[key] = value
          }
          break

        case 'diaria':
          this.solicitacaoCirurgia[key] = ['', 0, undefined, null].includes(solicitacaoCirurgia[key]) ? null : value
          break

        case 'diariaUti':
          this.solicitacaoCirurgia[key] = ['', 0, undefined, null].includes(solicitacaoCirurgia[key]) ? null : value
          break

        case 'tempoDeDoenca':
          this.solicitacaoCirurgia.tempoDeDoenca = solicitacaoCirurgia.tempoDeDoenca
            ? { ...solicitacaoCirurgia.tempoDeDoenca }
            : { ...this.tempoDeDoencaDefault }
          break

        case 'protocoloDeCirurgia':
          const { tecnicaDeCirurgia, segueOProtocolo } = value
          const tecnicaDeCirurgiaId = tecnicaDeCirurgia ? tecnicaDeCirurgia.id : undefined

          let medicoRecusouSeguirOProtocolo = false
          if (segueOProtocolo === StatusDoProtocoloEnum.naoSegueOProtocolo) {
            medicoRecusouSeguirOProtocolo = true
          }

          this.solicitacaoCirurgia[key] = {
            ...value,
            tecnicaDeCirurgiaId,
            medicoRecusouSeguirOProtocolo,
          } as ProtocoloDeCirurgiaDaSolicitacao
          break

        case 'procedimento':
          const { tecnicasDisponiveis } = value
          if (tecnicasDisponiveis && !!tecnicasDisponiveis.length) EventBus.$emit('updateTecnicasDisponiveis', tecnicasDisponiveis)
          this.solicitacaoCirurgia[key] = value
          break

        case 'tipoAnestesia':
          if (solicitacaoCirurgia.tipoAnestesia && solicitacaoCirurgia.tipoAnestesia.length > 0) {
            if (!this.tipoAnestesiaCheckbox) { this.tipoAnestesiaCheckbox = [] }

            solicitacaoCirurgia.tipoAnestesia.forEach((tipoAnestesia: SolicitacaoTipoAnestesia) => {
              const tipo = tipoAnestesia.tipo.key
              this.tipoAnestesiaCheckbox.push(tipo)
              if (tipo === 'Outros' && tipoAnestesia.outrosTipoAnestesia) {
                this.outrosTipoAnestesia = tipoAnestesia.outrosTipoAnestesia as string
              }
            })
          }
          break

        case 'comorbidadesDoPaciente':
          if (solicitacaoCirurgia.comorbidadesDoPaciente && solicitacaoCirurgia.comorbidadesDoPaciente.length > 0) {
            this.solicitacaoCirurgia.comorbidadesDoPaciente = solicitacaoCirurgia.comorbidadesDoPaciente
            this.solicitacaoCirurgia.comorbidadesDoPaciente.forEach((comorbidade) => {
              this.comorbidadesDoPacienteCheckbox.push(comorbidade.comorbidade)
              switch (comorbidade.comorbidade) {
                case 'HistoricoDeCardiopatiaHisquemica':
                  this.solicitacaoCirurgia.historicoDeCardiopatiaHisquemicaEspecificar = comorbidade.informacao
                  break
                case 'HistoricoDeInsuficienciaCardiaca':
                  this.solicitacaoCirurgia.historicoDeInsuficienciaCardiacaEspecificar = comorbidade.informacao
                  break
                case 'HistoricoDeDoencaVascularCerebral':
                  this.solicitacaoCirurgia.historicoDeDoencaVascularCerebralEspecificar = comorbidade.informacao
                  break
                case 'Diabetes':
                  this.solicitacaoCirurgia.diabetesEspecificar = comorbidade.informacao
                  break
                case 'Obesidade':
                  this.solicitacaoCirurgia.obesidadeEspecificar = comorbidade.informacao
                  break
                case 'ArritimiaCardiacaPorFibrilacaoAuricular':
                  this.solicitacaoCirurgia.arritimiaCardiacaPorFibrilacaoAuricularEspecificar = comorbidade.informacao
                  break
                case 'PacientePossuiLiberacaDoClinicoOuCardiologista':
                  this.solicitacaoCirurgia.pacientePossuiLiberacaDoClinicoOuCardiologistaEspecificar = comorbidade.informacao
                  break
                default:
                  break
              }
            })
          }
          break

        case 'hospitalTipoAcomodacao':
          if (solicitacaoCirurgia.hospitalTipoAcomodacao && solicitacaoCirurgia.hospitalTipoAcomodacao.id) {
            this.solicitacaoCirurgia.hospitalTipoAcomodacaoId = solicitacaoCirurgia.hospitalTipoAcomodacao.id
          }
          break

        case 'convenioAssociadoId':
          if (solicitacaoCirurgia.convenioAssociadoId) {
            this.solicitacaoCirurgia.possuiConvenioAssociado = true
            this.solicitacaoCirurgia.convenioAssociadoId = solicitacaoCirurgia.convenioAssociadoId
          } else {
            this.solicitacaoCirurgia.possuiConvenioAssociado = false
          }
          break

        default:
          this.solicitacaoCirurgia[key] = value
          break
      }
    })

    // Quando o template trouxer somente uma opção de campo, colocamos ele como default
    const { formulario } = this.template
    const caraterCampos = formulario.carater && formulario.carater.campos && formulario.carater.habilitado
      ? formulario.carater.campos
      : {}

    const tipoProcedimentoCampos = formulario.tipoProcedimento && formulario.tipoProcedimento.campos && formulario.tipoProcedimento.habilitado
      ? formulario.tipoProcedimento.campos
      : {}

    // Valores dos campos
    const caraterValues = {
      eletivo: 'EletivoAutorizacao',
      urgencia: 'Urgencia',
      emergencia: 'EletivoSemAutorizacao',
    }

    const tipoProcedimentoValues = {
      ambulatorial: 'Ambulatorial',
      internacao: 'Internacao',
      hospitalDia: 'HospitalDia',
    }

    this.solicitacaoCirurgia.carater = setValorDoCampoUnico(caraterCampos, caraterValues, this.solicitacaoCirurgia.carater)
    this.solicitacaoCirurgia.tipoProcedimento = setValorDoCampoUnico(tipoProcedimentoCampos, tipoProcedimentoValues, this.solicitacaoCirurgia.tipoProcedimento)

    // Gambiarra para apontar recém-nascido a partir do tipoPaciente = RecemNascido
    if (this.template.formulario.documentacaoObrigatoriaDoPaciente && this.template.formulario.documentacaoObrigatoriaDoPaciente.obrigatorio) {
      // @ts-ignore
      this.solicitacaoCirurgia.paciente.recemNascido = !!(this.solicitacaoCirurgia.paciente.tipoPaciente === TipoPacienteEnum.RecemNascido)
    }
  }

  @Mutation
  setSolicitacaoCirurgia(solicitacaoCirurgia: SolicitacaoCirurgia) {
    this.solicitacaoCirurgia = solicitacaoCirurgia

    if (solicitacaoCirurgia.paciente.celular) {
      this.solicitacaoCirurgia.paciente.celular = flatPhone(solicitacaoCirurgia.paciente.celular)
    }

    if (solicitacaoCirurgia.paciente.telefone) {
      this.solicitacaoCirurgia.paciente.telefone = flatPhone(solicitacaoCirurgia.paciente.telefone)
    }
  }

  @Mutation
  setLocalAtendimentoId(value: string | null) {
    this.solicitacaoCirurgia.localAtendimentoId = value
  }

  @Mutation
  clearReservaHemocomponentes() {
    this.solicitacaoCirurgia.reservaHemocomponentes = { ...this.reservaHemocomponenteDefault }
  }

  @Action
  clearSolicitacaoCirurgia() {
    this.context.commit('clearSolicitacaoCirurgiaMutation')
    this.context.commit('clearProtocolo')
    this.context.commit('clearModelosCirurgia')
    this.context.commit('clearDocumentosObrigatorios')
  }

  @Mutation
  clearDocumentosObrigatorios() {
    this.documentosObrigatoriosOptions = []
  }

  @Mutation
  clearSolicitacaoCirurgiaMutation() {
    this.solicitacaoCirurgia = { ...this.solicitacaoCirurgiaDefault }
    this.solicitacaoCirurgia.paciente = { ...this.pacienteDefault }
    this.solicitacaoCirurgia.tempoDeDoenca = { ...this.tempoDeDoencaDefault }
    this.solicitacaoCirurgia.reservaHemocomponentes = { ...this.reservaHemocomponenteDefault }
    this.solicitacaoCirurgia.reservaHemocomponentes.tipagemSanguineaABORHPAI.quantidade = 0
    this.solicitacaoCirurgia.reservaHemocomponentes.concentradoHemacias.quantidade = 0
    this.solicitacaoCirurgia.reservaHemocomponentes.concentradoPlaquetas.quantidade = 0
    this.solicitacaoCirurgia.reservaHemocomponentes.crioprecipitado.quantidade = 0
    this.solicitacaoCirurgia.reservaHemocomponentes.plasmaFrescoCongelado.quantidade = 0
    this.solicitacaoCirurgia.reservaHemocomponentes.semReserva.quantidade = 0
    this.hemocomponentesCheckbox = []
    this.examesIntraOperatoriosCheckbox = []
    this.solicitacaoCirurgia.solicitacaoMedicoConvidado.celular = ''
    this.solicitacaoCirurgia.solicitacaoMedicoConvidado.medicoConvidado = ''
    this.solicitacaoCirurgia.solicitacaoMedicoConvidado.codigoConselho = ''
    this.solicitacaoCirurgia.solicitacaoMedicoConvidado.nome = ''
    this.categorias = [...this.categoriasDefault]
    this.firstStep = true
    this.step = 1
    this.solicitacaoCirurgia.grupoDeOpme = { descricao: '', opmes: [] }
    this.todosProcedimentosHospitalDia = false
    this.tipoAnestesiaCheckbox = []
  }

  @Mutation
  clearProtocolo() {
    this.selectedProtocolo = {} as IProtocolo
    this.selectedProtocoloKitV2 = {} as IProtocoloKitDeOpmeV2Solicitacao
    this.protocoloOptions = []
    this.solicitacaoCirurgia.protocoloDeCirurgia = {
      segueOProtocolo: null,
      statusDoProtocolo: '',
      protocoloDeCirurgiaId: '',
      tecnicaDeCirurgiaId: '',
      tecnicaDeCirurgia: {
        id: '',
        nome: '',
      },
      medicoRecusouSeguirOProtocolo: false,
      kitDeOpmeId: '',
    } as ProtocoloDeCirurgiaDaSolicitacao
  }

  @Mutation
  setTemplate(template: any) {
    this.template = template
  }

  @Mutation
  setHospital(hospital: any) {
    this.solicitacaoCirurgia.hospital.id = hospital.id
    this.solicitacaoCirurgia.hospital.nome = hospital.nome
    if (hospital.hospitalFazConsultaCoberturaVigente !== undefined) this.solicitacaoCirurgia.hospital.hospitalFazConsultaCoberturaVigente = hospital.hospitalFazConsultaCoberturaVigente
    if (hospital.tipoDeCoberturaVigente !== undefined) this.solicitacaoCirurgia.hospital.tipoDeCoberturaVigente = hospital.tipoDeCoberturaVigente
    if (hospital.utilizaTipoAcomodacaoHospital !== undefined) this.solicitacaoCirurgia.hospital.utilizaTipoAcomodacaoHospital = hospital.utilizaTipoAcomodacaoHospital
    this.solicitacaoCirurgia.hospital.usaProcedimentosApenasHospitalDia = !!hospital.usaProcedimentosApenasHospitalDia
    this.solicitacaoCirurgia.hospital.urlAssinatura = hospital.urlAssinatura
    this.solicitacaoCirurgia.hospital.hospitalExigeDocumentacaoDoPacienteQuandoCaraterUrgencia = hospital.hospitalExigeDocumentacaoDoPacienteQuandoCaraterUrgencia
    this.solicitacaoCirurgia.hospital.hospitalIntegraComAutorizadorAntesDaReserva = hospital.hospitalIntegraComAutorizadorAntesDaReserva
  }

  @Mutation
  clearAll() {
    this.solicitacaoCirurgia = { ...this.solicitacaoCirurgiaDefault }
    this.convenios = []
    this.locaisAtendimento = []
    this.modelosCirurgia = [{ id: '', nomeCirurgia: 'Nova Cirurgia', tipo: '' }]
    this.step = 0
  }

  @Mutation
  setSolicitacaoId(id: string) {
    this.solicitacaoCirurgia.id = id
  }

  @Mutation
  clearHemocomponenteField(checkbox: string) {
    this.solicitacaoCirurgia.reservaHemocomponentes[checkbox].quantidade = 0
    this.solicitacaoCirurgia.reservaHemocomponentes[checkbox].value = false
  }

  @Mutation
  clearPrecisaEquipeHospital() {
    this.solicitacaoCirurgia.examesIntraOperatorios.ultrassonografiaIntraoperatoriaEquipeDoHospital = null
  }

  @Mutation
  clearOutrosExamesIntraOperatoriosEspecificar() {
    this.solicitacaoCirurgia.examesIntraOperatorios.outrosEspecificar = null
  }

  @Mutation
  clearAnatomiaPatologicaHospitalOuParticular() {
    this.solicitacaoCirurgia.examesIntraOperatorios.anatomiaPatologicaHospitalOuParticular = null
  }

  @Mutation
  clearAnatomiaPatologicaParticularLocal() {
    this.solicitacaoCirurgia.examesIntraOperatorios.anatomiaPatologicaParticularLocal = null
  }

  @Mutation
  clearBiopsiaHospitalOuParticular() {
    this.solicitacaoCirurgia.examesIntraOperatorios.biopsiaHospitalOuParticular = null
  }

  @Mutation
  clearBiopsiaParticularLocal() {
    this.solicitacaoCirurgia.examesIntraOperatorios.biopsiaParticularLocal = null
  }

  @Mutation
  clearMedicamentoEspeciaisEspecificar() {
    this.solicitacaoCirurgia.medicamentosEspeciais = ''
  }

  @Mutation
  clearEquipeMedicaEspecificar() {
    this.solicitacaoCirurgia.equipeMedica = ''
  }

  @Mutation
  clearOpmeDoConsultorioEspecificar() {
    this.solicitacaoCirurgia.opmeDoConsultorio = ''
  }

  @Mutation
  clearInstrumentadorExternoEspecificar() {
    this.solicitacaoCirurgia.instrumentadorExterno = ''
  }

  @Mutation
  clearInternacaoDeVesperaEspecificar() {
    this.solicitacaoCirurgia.internacaoDeVespera = ''
  }

  @Mutation
  clearMedicacaoContinuaEspecificar() {
    this.solicitacaoCirurgia.medicacaoContinua = ''
  }

  @Mutation
  clearPrevisaoUsoQuimioterapico() {
    this.solicitacaoCirurgia.previsaoUsoQuimioterapico = ''
  }

  @Mutation
  verificarIntraOperatorioValue() {
    Object.entries(this.solicitacaoCirurgia.examesIntraOperatorios).forEach(([key, value]) => {
      if ([
        'ultrassonografiaIntraoperatoriaEquipeDoHospital',
        'outrosEspecificar',
        'anatomiaPatologicaHospitalOuParticular',
        'anatomiaPatologicaParticularLocal',
        'biopsiaHospitalOuParticular',
        'biopsiaParticularLocal',
      ].includes(key)) {
        this.solicitacaoCirurgia.examesIntraOperatorios[key] = value
      } else {
        this.solicitacaoCirurgia.examesIntraOperatorios[key] = this.examesIntraOperatoriosCheckbox.includes(key)
      }
    })
  }

  @Mutation
  setReservaHemocomponentes(hemocomponentes: Hemocomponente[]) {
    Object.entries(hemocomponentes).forEach(([key, value]) => {
      const temp: any = _.camelCase(value.tipo) === 'tipagemSanguineaAborhpai' ? 'tipagemSanguineaABORHPAI' : _.camelCase(value.tipo)
      this.solicitacaoCirurgia.reservaHemocomponentes[temp].quantidade = value.quantidade
      this.solicitacaoCirurgia.reservaHemocomponentes[temp].value = true
      this.hemocomponentesCheckbox.push(temp)
    })
  }

  @Mutation
  clearEspecificarPrecaucoes() {
    this.solicitacaoCirurgia.especificarPrecaucoes = ''
  }

  @Mutation
  setMedicoGrupoOpmes(grupoOpmes: any[]) {
    this.medicoGrupoOpmes = grupoOpmes
  }

  @Mutation
  clearMedicoGrupoOpmes() {
    this.medicoGrupoOpmes = []
  }

  @Mutation
  setFornecedores(fornecedores: Fornecedor[]) {
    this.fornecedores = fornecedores
  }

  @Mutation
  opmeEnabled(opmeId: string) {
    this.listaMedicoOpme.map((c) => {
      const e = c
      if (e.id === opmeId) {
        e.disabled = true
      }
      return e
    })
  }

  @Mutation
  opmeDisabledChangeOnDelete() {
    this.listaMedicoOpme.map((c) => {
      const e = c
      e.disabled = this.grupoOpme.opmes.some(d => d.opme.id === e.id)
      return e
    })
  }

  @Mutation
  setOpmeIdChange() {
    this.grupoOpme.opmes.map((d) => {
      const e = d
      e.opmeId = e.opme.id
      return e
    })
  }

  @Mutation
  clearFornecedores() {
    this.fornecedores = []
  }

  @Mutation
  clearGrupoOpme() {
    this.grupoOpme = { ...this.grupoOpmeDefault }
    this.grupoOpme.opmes = [
      {
        quantidade: 0,
        quantidadeMinima: 0,
        quantidadeMaxima: 0,
        procedimentoBilateral: {
          quantidadeMaxima: 0,
        },
        medidaTamanho: '',
        fornecedores: [],
        opmeId: '',
        opme: {
          possuiGrade: false,
          id: '',
          descricao: '',
        },
        gradeCompleta: false,
      },
    ]
  }

  @Mutation
  clearNovoOPME() {
    this.novoOPME = { ...this.novoOPMEDefault }
  }

  @Mutation
  setConsultaPacienteCpf(paciente: ConsultaPacienteCpf) {
    if (paciente && paciente.paciente) {
      Object.entries(paciente.paciente).forEach(([key, value]) => {
        switch (key) {
          case 'dataNascimento':
            this.solicitacaoCirurgia.paciente[key] = moment(value).format('YYYY-MM-DD')
            break
          case 'celular':
            this.solicitacaoCirurgia.paciente[key] = flatPhone(value)
            break
          case 'telefone':
            this.solicitacaoCirurgia.paciente[key] = flatPhone(value)
            break
          default:
            this.solicitacaoCirurgia.paciente[key] = value
            break
        }
      })
      // Verifica se no primeiro passo não existe categoria ou plano para permitir a validação
      const { categoriaId, planoId } = this.solicitacaoCirurgia.paciente
      if (categoriaId === '' && this.firstStep) this.categorias = []
      if (planoId === '' && this.firstStep) this.planos = []
    } else {
      const { cpf } = this.solicitacaoCirurgia.paciente
      const { rgh } = this.solicitacaoCirurgia.paciente
      this.solicitacaoCirurgia.paciente = { ...this.pacienteDefault }
      this.solicitacaoCirurgia.paciente.cpf = cpf
      this.solicitacaoCirurgia.paciente.rgh = rgh
    }
  }

  @Mutation
  setAdicionaPaciente(paciente: Paciente) {
    if (paciente) {
      Object.entries(paciente).forEach(([key, value]) => {
        switch (key) {
          case 'dataNascimento':
            this.solicitacaoCirurgia.paciente[key] = moment(value).format('YYYY-MM-DD')
            break
          case 'celular':
            this.solicitacaoCirurgia.paciente[key] = flatPhone(value)
            break
          case 'telefone':
            this.solicitacaoCirurgia.paciente[key] = flatPhone(value)
            break
          default:
            this.solicitacaoCirurgia.paciente[key] = value
            break
        }
      })
    } else {
      const { cpf } = this.solicitacaoCirurgia.paciente
      this.solicitacaoCirurgia.paciente = { ...this.pacienteDefault }
      this.solicitacaoCirurgia.paciente.cpf = cpf
    }
  }

  @Mutation
  clearConsultaPacienteCpf() {
    this.consultaPacienteCpf = { ...this.consultaPacienteCpfDefault }
  }

  @Mutation
  setConsultaPacienteNome(paciente: Paciente) {
    if (paciente) {
      Object.entries(paciente).forEach(([key, value]) => {
        switch (key) {
          case 'dataNascimento':
            this.solicitacaoCirurgia.paciente[key] = moment(value).format('YYYY-MM-DD')
            break
          case 'celular':
            this.solicitacaoCirurgia.paciente[key] = flatPhone(value)
            break
          case 'telefone':
            this.solicitacaoCirurgia.paciente[key] = flatPhone(value)
            break
          case 'pacienteNaoPossuiCpf':
            this.solicitacaoCirurgia.paciente.pacienteNaoPossuiCpf = !paciente.cpf
            if (!paciente.cpf) this.solicitacaoCirurgia.paciente.cpf = ''
            break
          default:
            this.solicitacaoCirurgia.paciente[key] = value
            break
        }
      })
    } else {
      const { cpf } = this.solicitacaoCirurgia.paciente
      this.solicitacaoCirurgia.paciente = { ...this.pacienteDefault }
      this.solicitacaoCirurgia.paciente.cpf = cpf
    }
  }

  @Mutation
  clearConsultaPacienteNome() {
    this.solicitacaoCirurgia.paciente = { ...this.pacienteDefault }
  }

  @Mutation
  setPacienteField({ field, value }: { field: string, value: any }) {
    this.solicitacaoCirurgia.paciente[field] = value
  }

  @Mutation
  setPacienteId(id: string) {
    this.solicitacaoCirurgia.paciente.id = id
  }

  @Mutation
  setGradeMedicaEventos(gradeMedicaEventos: GradeMedicaEvento[]) {
    this.gradeMedicaEventos = gradeMedicaEventos
  }

  @Mutation
  clearGradeMedicaEventos() {
    this.gradeMedicaEventos = [...this.gradeMedicaEventosDefault]
  }

  @Action
  forceCast<T>(obj: any) {
    return obj
  }

  @Action({ commit: 'setCategorias' })
  async getAllCategoriasByConvenio() {
    try {
      const params: any = {
        convenioId: this.solicitacaoCirurgia.paciente.convenioId,
        hospitalId: this.solicitacaoCirurgia.hospitalId,
      }

      const response = await this.solicitacaoCirurgiaImp.getAllCategoriasByConvenio(params)
      return response.success ? response.data : []
    } catch (error) {
      return []
    }
  }

  @Action({ commit: 'setCategorias' })
  async getAllCategoriasByConvenioId(payload: any) {
    try {
      const params: any = {
        convenioId: payload.convenioId,
        hospitalId: this.solicitacaoCirurgia.hospitalId,
      }

      const response = await this.solicitacaoCirurgiaImp.getAllCategoriasByConvenio(params)
      return response.success ? response.data : []
    } catch (error) {
      return []
    }
  }

  @Action({ commit: 'setCategorias' })
  async getAllCategoriasByPlano(planoId: string) {
    try {
      const params: any = {
        hospitalId: this.hospitalId,
        convenioId: this.solicitacaoCirurgia.paciente.convenioId,
        planoId,
      }

      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getAllCategoriasByPlano(params)
      return request.success ? request.data : []
    } catch (error) {
      return []
    }
  }

  @Action({ commit: 'setCategoriasAssociadas' })
  async getAllCategoriasAssociadasByPlano(planoId: string) {
    try {
      const params: any = {
        hospitalId: this.hospitalId,
        convenioId: this.solicitacaoCirurgia.convenioAssociadoId,
        planoId,
      }

      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getAllCategoriasByPlano(params)
      return request.success ? request.data : []
    } catch (error) {
      return []
    }
  }

  @Action
  async getSolicitacaoById(solicitacaoId: string) {
    const response = await this.solicitacaoCirurgiaImp.get(solicitacaoId)
    if (response.success) {
      // Set cirurgia
      this.context.commit('setGetSolicitacaoCirurgia', response.data)
      this.context.commit('verificarIntraOperatorioValue')

      // Set locais de atendimento
      const { medicoSolicitanteId, hospitalId } = this.solicitacaoCirurgia
      const request = await this.solicitacaoCirurgiaImp.getAllLocalAtendimento(medicoSolicitanteId, hospitalId)
      if (request.success) this.context.commit('setLocaisAtendimento', request.data as LocalAtendimento[])

      // Tenta carregar os protocolos
      await this.context.dispatch('loadProtocoloOptions')

      // Tentar preencher o protocolo caso já exista um selecionado
      this.context.commit('protocoloChange', false)

      // Verifica se a cirurgia tem protocolo e não foi respondido nada
      // Trata exatamente dos casos em que uma cirurgia foi criada a partir de um modelo de cirurgia
      this.context.dispatch('checkExistProtocoloParaOProcedimentoAoCarregarSolicitacao')
    }

    return response
  }

  @Action
  async postPaciente() {
    const params: any = {
      hospitalId: this.hospitalId,
      nome: this.solicitacaoCirurgia.paciente.nome,
      cpf: this.solicitacaoCirurgia.paciente.cpf,
      tipoPaciente: this.solicitacaoCirurgia.paciente.tipoPaciente,
      cpfResponsavel: this.solicitacaoCirurgia.paciente.cpfResponsavel,
      rne: this.solicitacaoCirurgia.paciente.rne,
      passaporte: this.solicitacaoCirurgia.paciente.passaporte,
      paisId: this.solicitacaoCirurgia.paciente.paisId,
      certidaoNascimentoLivro: this.solicitacaoCirurgia.paciente.certidaoNascimentoLivro,
      certidaoNascimentoFolha: this.solicitacaoCirurgia.paciente.certidaoNascimentoFolha,
      certidaoNascimentoTermo: this.solicitacaoCirurgia.paciente.certidaoNascimentoTermo,
      nomeSocial: this.solicitacaoCirurgia.paciente.nomeSocial,
      dataNascimento: this.solicitacaoCirurgia.paciente.dataNascimento,
      sexo: this.solicitacaoCirurgia.paciente.sexo,
      convenioId: this.solicitacaoCirurgia.paciente.convenioId,
      planoId: this.solicitacaoCirurgia.paciente.planoId,
      categoriaId: this.solicitacaoCirurgia.paciente.categoriaId,
      categoriaCoberturaVigente: this.solicitacaoCirurgia.paciente.categoriaCoberturaVigente,
    }

    Object.entries(params).forEach(([key, value]) => {
      if (['', null, undefined].includes(value as any)) delete params[key]
    })

    const response = await this.solicitacaoCirurgiaImp.postPaciente(params)
    return response
  }

  @Action
  async postFornecedor() {
    const fornecedor = {
      ...this.novoFornecedor,
      medicoId: this.solicitacaoCirurgia.medicoSolicitanteId,
      hospitalId: this.solicitacaoCirurgia.hospitalId,
      nomeFabricante: [null, undefined, ''].includes(this.novoFornecedor.nomeFabricante) ? '' : this.novoFornecedor.nomeFabricante,
      contato: formatPhoneMask(this.novoFornecedor.contato),
    }

    const response = await this.solicitacaoCirurgiaImp.postForncecedor(fornecedor)

    if (response.success) {
      this.context.dispatch('loadFornecedores')
      this.context.commit('clearNovoFornecedor')
    }
    return response
  }

  @Action
  async post() {
    const params: any = {
      medicoSolicitanteId: this.solicitacaoCirurgia.medicoSolicitanteId,
      paciente: this.solicitacaoCirurgia.paciente,
      modeloCirurgiaId: this.solicitacaoCirurgia.modeloCirurgiaId,
      hospitalId: this.solicitacaoCirurgia.hospitalId,
    }

    if (['', null, undefined].includes(params.modeloCirurgiaId)) {
      delete params.modeloCirurgiaId
    }

    const clearFields = clearEmptyFields(params)
    const response = await this.solicitacaoCirurgiaImp.post(clearFields)

    if (response.success) {
      this.context.commit('setFirstStep', false)
      this.context.commit('setSolicitacaoId', response.data)
    }
    return response
  }

  @Action
  async finalizar() {
    const solicitacaoId = this.solicitacaoCirurgia.id
    const response = await this.solicitacaoCirurgiaImp.finalizar(solicitacaoId)
    return response
  }

  @Action
  async createOrcamentoAvulso(data: Partial<SolicitacaoCirurgia> = {}) {
    const solicitacaoCirurgia = {
      ...this.solicitacaoCirurgia,
      ...data,
    }

    if (solicitacaoCirurgia.procedimento && solicitacaoCirurgia.procedimento.id) {
      const procedimento = solicitacaoCirurgia.procedimento as any
      procedimento.lateralidade = procedimento.lateralidade && procedimento.lateralidade.key ? procedimento.lateralidade.key : procedimento.lateralidade
      if ([undefined, null].includes(procedimento.lateralidade)) procedimento.lateralidade = 'NaoAplica'
      procedimento.procedimentoId = procedimento.id
      procedimento.procedimentoPrincipal = true
    } else {
      solicitacaoCirurgia.procedimento = undefined
    }

    if (solicitacaoCirurgia.procedimentosAssociados) {
      // eslint-disable-next-line no-return-assign
      solicitacaoCirurgia.procedimentosAssociados = solicitacaoCirurgia.procedimentosAssociados.map((elem: any) => {
        let lateralidade = elem.lateralidade && elem.lateralidade.key ? elem.lateralidade.key : elem.lateralidade
        if ([undefined, null].includes(lateralidade)) lateralidade = 'NaoAplica'
        return {
          ...elem,
          procedimentoId: elem.id,
          lateralidade,
        }
      })
    }

    let opmes: SolicitacaoOpme[] = undefined!
    if (solicitacaoCirurgia.grupoDeOpme && solicitacaoCirurgia.grupoDeOpme.opmes.length > 0) {
      // eslint-disable-next-line prefer-destructuring
      opmes = solicitacaoCirurgia.grupoDeOpme!.opmes
    }

    const { id, nome, cpf, dataNascimento, sexo, convenioId, planoId, categoriaId, hisId } = solicitacaoCirurgia.paciente
    const paciente = {
      id: id || undefined,
      nome,
      cpf,
      dataNascimento,
      sexo,
      convenioId: convenioId || undefined,
      planoId: planoId || undefined,
      categoriaId: categoriaId || undefined,
      hisId,
    }

    const creationData = {
      medicoSolicitanteId: solicitacaoCirurgia.medicoSolicitanteId,
      hospitalId: solicitacaoCirurgia.hospitalId,
      tipoProcedimento: solicitacaoCirurgia.tipoProcedimento,
      paciente,
      procedimentos: [solicitacaoCirurgia.procedimento, ...solicitacaoCirurgia.procedimentosAssociados!],
      opmes,
      reservaUti: solicitacaoCirurgia.reservaUTI,
      diariaUti: solicitacaoCirurgia.diariaUti || 0,
      tecnicaDaCirurgia: solicitacaoCirurgia.tecnicaDaCirurgia,
      tipoAcomodacao: solicitacaoCirurgia.tipoAcomodacao || undefined,
      hospitalTipoAcomodacaoId: solicitacaoCirurgia.hospitalTipoAcomodacaoId || undefined,
      convenioAssociadoId: solicitacaoCirurgia.convenioAssociadoId || undefined,
      planoAssociadoId: solicitacaoCirurgia.planoAssociadoId || undefined,
      categoriaAssociadaId: solicitacaoCirurgia.categoriaAssociadaId || undefined,
      diaria: solicitacaoCirurgia.diaria,
      temOpmeDoConsultorio: solicitacaoCirurgia.temOpmeDoConsultorio || undefined,
      opmeDoConsultorio: solicitacaoCirurgia.opmeDoConsultorio || undefined,
      anestesiaDoHospital: solicitacaoCirurgia.anestesiaDoHospital || undefined,
      nomeAnestesista: solicitacaoCirurgia.nomeAnestesista || undefined,
      instrucaoDataPrevista: solicitacaoCirurgia.instrucaoDataPrevista || undefined,
      tempoCirurgia: solicitacaoCirurgia.tempoCirurgia,
    }

    const response = await SolicitacaoCirurgiaApi.createOrcamentoAvulso(creationData)
    return response
  }

  @Action
  async put(data: Partial<SolicitacaoCirurgia> = {}) {
    const solicitacaoCirurgia = {
      ...this.solicitacaoCirurgia,
      ...data,
    }

    if (solicitacaoCirurgia.procedimento && solicitacaoCirurgia.procedimento.id) {
      const procedimento = solicitacaoCirurgia.procedimento as any
      procedimento.lateralidade = procedimento.lateralidade && procedimento.lateralidade.key ? procedimento.lateralidade.key : procedimento.lateralidade
      if ([undefined, null].includes(procedimento.lateralidade)) procedimento.lateralidade = 'NaoAplica'
      procedimento.procedimentoId = procedimento.id
    } else {
      solicitacaoCirurgia.procedimento = undefined
    }

    if (solicitacaoCirurgia.procedimentosAssociados) {
      // eslint-disable-next-line no-return-assign
      solicitacaoCirurgia.procedimentosAssociados = solicitacaoCirurgia.procedimentosAssociados.map((elem: any) => {
        let lateralidade = elem.lateralidade && elem.lateralidade.key ? elem.lateralidade.key : elem.lateralidade
        if ([undefined, null].includes(lateralidade)) lateralidade = 'NaoAplica'
        return {
          ...elem,
          procedimentoId: elem.id,
          lateralidade,
        }
      })
    }

    if (solicitacaoCirurgia.opcaoDataPrevisto1) {
      solicitacaoCirurgia.opcaoDataPrevisto1 = moment(solicitacaoCirurgia.opcaoDataPrevisto1).format('YYYY-MM-DDTHH:mm')
    }

    if (solicitacaoCirurgia.opcaoDataPrevisto2) {
      solicitacaoCirurgia.opcaoDataPrevisto2 = moment(solicitacaoCirurgia.opcaoDataPrevisto2).format('YYYY-MM-DDTHH:mm')
    }

    if (solicitacaoCirurgia.opcaoDataPrevisto3) {
      solicitacaoCirurgia.opcaoDataPrevisto3 = moment(solicitacaoCirurgia.opcaoDataPrevisto3).format('YYYY-MM-DDTHH:mm')
    }

    if (solicitacaoCirurgia.paciente.celular) {
      solicitacaoCirurgia.paciente.celular = flatPhone(solicitacaoCirurgia.paciente.celular)
    }

    if (solicitacaoCirurgia.paciente.telefone) {
      solicitacaoCirurgia.paciente.telefone = flatPhone(solicitacaoCirurgia.paciente.telefone)
    }

    if (solicitacaoCirurgia.examesIntraOperatorios.outrosEspecificar) {
      solicitacaoCirurgia.especificacaoExameIntraOperatorio = solicitacaoCirurgia.examesIntraOperatorios.outrosEspecificar
    }

    // Força o valor SemReserva para a reserva de UTI quando o procedimento for ambulatorial...
    if (
      opcaoHabilitadoShared(this.template, 'formularioMedico', 'limparReservaUtiNoTipoDeInternacaoAmbulatorial')
      && opcaoHabilitadoShared(this.template, 'tipoProcedimento', 'ambulatorial')
      && opcaoHabilitadoShared(this.template, 'reservaUti', 'semReservaUti')
    ) {
      if (solicitacaoCirurgia.tipoProcedimento === 'Ambulatorial') {
        solicitacaoCirurgia.reservaUTI = 'SemReserva'
        if (solicitacaoCirurgia.diaria) solicitacaoCirurgia.diaria = 0
        if (solicitacaoCirurgia.diariaUti) solicitacaoCirurgia.diariaUti = 0
      }
    }

    const clearFields = clearEmptyFields(solicitacaoCirurgia)

    clearFields.dataAgendamentoVirtual = clearFields.medicoSolicitouDataVirtual

    if (this.currentTemplate.formulario
      && this.currentTemplate.formulario.nacionalidade
      && this.currentTemplate.formulario.nacionalidade.habilitado
    ) {
      const PAIS = clearFields.paciente.paisId
        ? this.paises.find((pais: any) => pais.id === clearFields.paciente.paisId)
        : this.paises.find((pais: any) => pais.isoCode === 'br')
      clearFields.paciente.ddi = PAIS.ddi
      clearFields.paciente.paisId = PAIS.id
    }

    if (clearFields.honorarioMedicoDocumento) {
      clearFields.honorarioMedicoDocumento = clearFields.honorarioMedicoDocumento.replace(/\./g, '').replace(/-/g, '').replace(/\//g, '')
    }

    if (solicitacaoCirurgia.protocoloDeCirurgia) {
      if (
        solicitacaoCirurgia.protocoloDeCirurgia.segueOProtocolo !== StatusDoProtocoloEnum.segueOProtocolo
        && solicitacaoCirurgia.protocoloDeCirurgia.medicoRecusouSeguirOProtocolo === false
      ) {
        delete solicitacaoCirurgia.protocoloDeCirurgia
      } else {
        // Limpa os campos nulos ou vazios do protocolo
        Object.entries(solicitacaoCirurgia.protocoloDeCirurgia).forEach(([key, value]) => {
          if ([null, '', undefined].includes(value)) {
            delete solicitacaoCirurgia!.protocoloDeCirurgia![key]
          }

          if (key === 'tecnicaDeCirurgia' && value.id === '') {
            delete solicitacaoCirurgia!.protocoloDeCirurgia![key]
          }
        })

        if (solicitacaoCirurgia.protocoloDeCirurgia.segueOProtocolo === StatusDoProtocoloEnum.naoSegueOProtocolo) {
          solicitacaoCirurgia.protocoloDeCirurgia.medicoRecusouSeguirOProtocolo = true
        }
      }
    }

    // if (
    //   solicitacaoCirurgia.procedimento
    //   && solicitacaoCirurgia.procedimento.tecnicaDoProcedimento
    //   && solicitacaoCirurgia.procedimento.tecnicaDoProcedimento.id
    // ) {
    //   solicitacaoCirurgia.procedimento.tecnicaDoProcedimentoId = solicitacaoCirurgia.procedimento.tecnicaDoProcedimento.id
    // }
    //   }
    // }

    if (solicitacaoCirurgia.grupoDeOpme && solicitacaoCirurgia.grupoDeOpme.opmes.length === 0) {
      delete solicitacaoCirurgia.grupoDeOpme
    }

    if (this.tipoAnestesiaCheckbox && this.tipoAnestesiaCheckbox.length > 0) {
      if (!solicitacaoCirurgia.tipoAnestesia) {
        solicitacaoCirurgia.tipoAnestesia = []
      }

      this.tipoAnestesiaCheckbox.forEach((tipo: string) => {
        if (tipo === 'Outros') {
          solicitacaoCirurgia.tipoAnestesia!.push({ tipo, outrosTipoAnestesia: this.outrosTipoAnestesia } as SolicitacaoTipoAnestesia)
        } else {
          solicitacaoCirurgia.tipoAnestesia!.push({ tipo } as SolicitacaoTipoAnestesia)
        }
      })
    }

    if (this.currentTemplate.formulario
      && this.currentTemplate.formulario.anestesiaHospital
      && this.currentTemplate.formulario.anestesiaHospital.habilitado
      && this.currentTemplate.formulario.anestesiaHospital.campos
      && this.currentTemplate.formulario.anestesiaHospital.campos.hospitalUtilizaClinicasDeAnestesia
    ) {
      if (!['', null, undefined].includes(this.outroAnestesista)) this.solicitacaoCirurgia.anestesista = 'Outros'
      if (this.solicitacaoCirurgia.anestesista && typeof this.solicitacaoCirurgia.anestesista === 'object') {
        this.solicitacaoCirurgia.anestesista = {
          id: this.solicitacaoCirurgia.anestesista.id,
          nome: this.solicitacaoCirurgia.anestesista.nome,
          temVinculoHospital: this.solicitacaoCirurgia.anestesista.temVinculoHospital,
        }
      }
    }
    const response = await this.solicitacaoCirurgiaImp.put(clearFields.id, clearFields)
    return response
  }

  @Action
  async uploadSolicitacaoDocumentos(params: any) {
    const solicitacaoId = this.solicitacaoCirurgia.id
    const formData = params.form
    const headers = params.header
    const response = await this.solicitacaoCirurgiaImp.upload(formData, params.tipo, headers, solicitacaoId)

    if (response.success) {
      this.context.commit('setLaudos', response.data)
    }

    return response
  }

  @Action({ commit: 'setLaudos' })
  async loadLaudos() {
    let documentos: any[] = []
    const request = await this.solicitacaoCirurgiaImp.getAllLaudos(this.solicitacaoCirurgia.id, TipoDocumentoUpload.Laudo)
    if (request.success) {
      const laudosCast = await this.forceCast<Laudo[]>(request.data)
      laudosCast.map((e: any) => {
        const c = e
        c.tipoDocumento = 'Laudo'
        return c
      })
      documentos = [...documentos, ...laudosCast]
      return documentos
    }

    return []
  }

  @Action
  async loadAllDocumentsByType(documentos: any) {
    if (documentos.anexos) {
      try {
        const request = await this.solicitacaoCirurgiaImp.getAllLaudos(this.solicitacaoCirurgia.id, TipoDocumentoUpload.Laudo)
        if (request.success) {
          const laudosCast = await this.forceCast<Laudo[]>([...request.data])

          laudosCast.map((e: any) => {
            const c = e
            c.tipoDocumento = 'Laudo'
            return c
          })

          this.context.commit('setLaudos', laudosCast)
        } else {
          this.context.commit('setLaudos', [])
        }
      } catch (error) {
        this.context.commit('setLaudos', [])
      }
    }

    if (documentos.documentacaoPaciente) {
      try {
        const request = await this.solicitacaoCirurgiaImp.getAllLaudos(this.solicitacaoCirurgia.id, TipoDocumentoUpload.DocumentacaoPaciente)
        if (request.success) {
          const documentacaoPacienteCast = await this.forceCast<Laudo[]>([...request.data])

          documentacaoPacienteCast.map((e: any) => {
            const c = e
            c.tipoDocumento = 'DocumentacaoPaciente'
            return c
          })

          this.context.commit('setLaudosPaciente', documentacaoPacienteCast)
        } else {
          this.context.commit('setLaudosPaciente', [])
        }
      } catch (error) {
        this.context.commit('setLaudosPaciente', [])
      }
    }

    if (documentos.documentosDiversos) {
      try {
        const request = await this.solicitacaoCirurgiaImp.getAllLaudos(this.solicitacaoCirurgia.id, TipoDocumentoUpload.DocumentosDiversos)
        if (request.success) {
          const documentosDiversosCast = await this.forceCast<Laudo[]>([...request.data])

          documentosDiversosCast.map((e: any) => {
            const c = e
            c.tipoDocumento = 'DocumentosDiversos'
            return c
          })

          this.context.commit('setLaudosDiversos', documentosDiversosCast)
        } else {
          this.context.commit('setLaudosDiversos', [])
        }
      } catch (error) {
        this.context.commit('setLaudosDiversos', [])
      }
    }

    if (documentos.termoDeConsentimento) {
      try {
        const request = await this.solicitacaoCirurgiaImp.getAllLaudos(this.solicitacaoCirurgia.id, TipoDocumentoUpload.TermoDeConsentimento)
        if (request.success) {
          const termoDeConsentimentoCast = await this.forceCast<Laudo[]>([...request.data])

          termoDeConsentimentoCast.map((e: any) => {
            const c = e
            c.tipoDocumento = 'TermoDeConsentimento'
            return c
          })

          this.context.commit('setLaudosTermoDeConsentimento', termoDeConsentimentoCast)
        } else {
          this.context.commit('setLaudosTermoDeConsentimento', [])
        }
      } catch (error) {
        this.context.commit('setLaudosTermoDeConsentimento', [])
      }
    }

    if (documentos.orcamentoDeCirurgiaParticularAprovado) {
      try {
        const request = await this.solicitacaoCirurgiaImp.getAllLaudos(this.solicitacaoCirurgia.id, TipoDocumentoUpload.OrcamentoDeCirurgiaParticularAprovado)
        if (request.success) {
          const orcamentoDeCirurgiaParticularAprovadoCast = await this.forceCast<Laudo[]>([...request.data])

          orcamentoDeCirurgiaParticularAprovadoCast.map((e: any) => {
            const c = e
            c.tipoDocumento = 'OrcamentoDeCirurgiaParticularAprovado'
            return c
          })

          this.context.commit('setLaudosOrcamentoDeCirurgiaParticularAprovado', orcamentoDeCirurgiaParticularAprovadoCast)
        } else {
          this.context.commit('setLaudosOrcamentoDeCirurgiaParticularAprovado', [])
        }
      } catch (error) {
        this.context.commit('setLaudosOrcamentoDeCirurgiaParticularAprovado', [])
      }
    }
  }

  @Action
  async sendSurgerySolicitationAuthorizationInfo(surgerySolicitationId: string) {
    const requestBody: any = {
      solicitacaoId: surgerySolicitationId,
    }

    const APIRequest = await Apis.Agendamento.SolicitacaoCirurgiaApi.sendSurgerySolicitationAuthorizationInfo({ surgerySolicitationId, requestBody })
    return APIRequest
  }

  @Action
  async getPacienteInfo(params: any) {
    const { documento: valor, tipoDocumentoBuscaPaciente, convenioId: healthInsuranceId } = params

    const query: any = {}

    if (healthInsuranceId) {
      query.convenioId = healthInsuranceId
    }

    if (tipoDocumentoBuscaPaciente === TipoDocumentoBuscaPacienteEnum.CPF) {
      query.cpf = clearCPF(valor)
    } else if (tipoDocumentoBuscaPaciente === TipoDocumentoBuscaPacienteEnum.CARTEIRINHA) {
      query.carteirinha = valor
    } else if (tipoDocumentoBuscaPaciente === TipoDocumentoBuscaPacienteEnum.NOME) {
      query.nome = valor
    } else {
      query.rgh = valor
    }

    const response = await this.solicitacaoCirurgiaImp.getPacienteByHospital(this.hospitalId, query)

    if (response.success) {
      if (response.data && response.data.paciente && !['', null, undefined].includes(response.data.paciente.convenioId)) {
        const { convenioId, planoId } = response.data.paciente
        await this.context.dispatch('getAllCategoriasByConvenioId', { convenioId })
        await this.context.dispatch('getAllPlanosByConvenioId', { convenioId })

        // Check can load modelos de cirurgia
        if (convenioId) {
          this.solicitacaoCirurgia.paciente.convenioId = convenioId
          this.solicitacaoCirurgia.paciente.planoId = planoId
          await this.context.dispatch('getModeloCirurgia')
        }
      }
      this.context.commit('setConsultaPacienteCpf', response.data)
    }
    return response
  }

  @Action
  async adicionaPaciente(params: any) {
    const response = await this.solicitacaoCirurgiaImp.adicionaPaciente(params)
    if (response.success) {
      this.context.commit('setAdicionaPaciente', response.data)
    }
    return response
  }

  @Action
  async getPacienteInfoByNomeAndDataNascimento(params: any) {
    const nome = params.nome.trim()
    const { dataNascimento, convenioId } = params
    const queryParams: {
      nome: string;
      dataNascimento: string;
      convenioId?: string;
    } = {
      nome,
      dataNascimento,
    }

    if (convenioId) {
      queryParams.convenioId = convenioId
    }

    const response = await this.solicitacaoCirurgiaImp.getPacienteByHospital(this.hospitalId, queryParams)
    if (response.success) {
      const pacientes = response.data.pacientes
        ? response.data.pacientes.map((e: any) => e.paciente)
        : []
      this.context.commit('setPacientesLista', pacientes)
    }

    return response
  }

  @Action
  async getHospitalById(hospitalId: string) {
    const response = await this.solicitacaoCirurgiaImp.getHospitalId(hospitalId)
    if (response.success) {
      this.context.commit('setHospital', response.data)
    }
    return response.data || {}
  }

  @Action
  async getTemplateHospital(hospitalId: string) {
    const response = await this.solicitacaoCirurgiaImp.getTemplateHospital(hospitalId)
    if (response.success) {
      this.context.commit('setHospitalNome', response.data.hospitalNome)
      this.context.commit('setTemplate', JSON.parse(response.data.template))
    }
    return response
  }

  @Action
  async postReservaHemocomponente(hemocomponente: Hemocomponente) {
    const response = await this.solicitacaoCirurgiaImp.postReservaHemocomponentes(hemocomponente)
    return response
  }

  @Action
  async deleteReservaHemocomponente(tipo: string) {
    const solicitacaoId = this.solicitacaoCirurgia.id
    const response = await this.solicitacaoCirurgiaImp.deleteReservaHemocomponente(tipo, solicitacaoId)
    return response
  }

  @Action
  async getReservaHemocomponente() {
    const solicitacaoId = this.solicitacaoCirurgia.id
    const response = await this.solicitacaoCirurgiaImp.getAllReservaHemocomponentes(solicitacaoId)

    if (response.success) {
      this.context.commit('setReservaHemocomponentes', response.data)
    }
    return response
  }

  @Action
  async getAllPlanos() {
    try {
      if (this.solicitacaoCirurgia.hospitalId && this.solicitacaoCirurgia.paciente.convenioId) {
        const response = await this.solicitacaoCirurgiaImp.getAllPlanos(this.solicitacaoCirurgia.hospitalId, this.solicitacaoCirurgia.paciente.convenioId)
        if (response.success) {
          this.context.commit('setPlanos', response.data)
        }
        return response
      }
      return []
    } catch (error) {
      return []
    }
  }

  @Action
  async getAllPlanosAssociados() {
    try {
      if (this.solicitacaoCirurgia.hospitalId && this.solicitacaoCirurgia.convenioAssociadoId) {
        const response = await this.solicitacaoCirurgiaImp.getAllPlanos(this.solicitacaoCirurgia.hospitalId, this.solicitacaoCirurgia.convenioAssociadoId)
        if (response.success) {
          this.context.commit('setPlanosAssociados', response.data)
        }
        return response
      }
      return []
    } catch (error) {
      return []
    }
  }

  @Action
  async getAllPlanosByConvenioId(payload: any) {
    try {
      if (this.solicitacaoCirurgia.hospitalId && payload.convenioId) {
        const response = await this.solicitacaoCirurgiaImp.getAllPlanos(this.solicitacaoCirurgia.hospitalId, payload.convenioId)
        if (response.success) {
          this.context.commit('setPlanos', response.data)
        }
        return response
      }
      return []
    } catch (error) {
      return []
    }
  }

  @Action
  async getAllConvenio(search: any) {
    try {
      const { hospitalId } = this.solicitacaoCirurgia
      const response = await this.solicitacaoCirurgiaImp.getAllConvenio(hospitalId)
      if (response.success) {
        if (search.somenteParticulares) {
          const conveniosParticulares = response.data.filter(convenio => convenio.particular === true)
          this.context.commit('setConvenios', conveniosParticulares)
        } else {
          this.context.commit('setConvenios', response.data)
        }

        if (this.template.formulario.possuiConvenioAssociado
          && (this.template.formulario.possuiConvenioAssociado.habilitado || this.template.formulario.possuiConvenioAssociado.habilitadoOrcamentoParticularAvulso)) {
          this.context.commit('setConveniosAssociados', response.data)
        }
      }
      return response
    } catch (error) {
      return []
    }
  }

  @Action
  async getCentroCirurgico() {
    try {
      const { hospitalId } = this.solicitacaoCirurgia
      const response = await this.solicitacaoCirurgiaImp.getCentroCirurgico({ hospitalIds: [hospitalId] })
      if (response.success) {
        this.context.commit('setCentroCirurgico', response.data)
      }
      return response
    } catch (error) {
      return []
    }
  }

  @Action
  async getModeloCirurgia() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })

    if (!this.solicitacaoCirurgia.paciente.convenioId) {
      return []
    }

    const response = await this.solicitacaoCirurgiaImp.getModeloCirurgia(
      this.hospitalId,
      this.medicoSolicitanteId,
      this.solicitacaoCirurgia.paciente.convenioId,
      this.solicitacaoCirurgia.paciente.planoId!,
    )

    if (response.success) {
      const { data } = response
      this.context.commit('setModelosCirurgia', data)
    }

    EventBus.$emit('clearLoadingRequest')

    return response
  }

  doctors: Array<{ id: string, nome: string }> = []

  @Mutation
  setDoctors(value: Array<{ id: string, nome: string }>) {
    this.doctors = value
  }

  @Mutation
  clearDoctors() {
    this.doctors = []
  }

  @Action
  async getDoctors() {
    try {
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getMedicoshospitalByUserCurrent()
      if (request.success) this.context.commit('setDoctors', request.data as Array<{ id: string, nome: string }>)
      return request
    } catch (error) {
      this.context.commit('clearDoctors')
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action({ commit: 'setProcedimentosApi' })
  async getProcedimentoSearch(searchText: string) {
    const { medicoSolicitanteId } = this.solicitacaoCirurgia
    const { hospitalId } = this.solicitacaoCirurgia
    const { convenioId } = this.solicitacaoCirurgia.paciente
    const response = await this.solicitacaoCirurgiaImp.getProcedimentoSearch(medicoSolicitanteId, hospitalId, convenioId, searchText)

    return response
  }

  @Action({ commit: 'setFornecedores' })
  async loadFornecedores() {
    const { hospitalId } = this.solicitacaoCirurgia
    const convenioId = this.solicitacaoCirurgia.paciente.convenioId || 'e8496173-7c9d-43b2-9f01-4d490d69042b'
    const request = await this.solicitacaoCirurgiaImp.getAllFornecedor(hospitalId, convenioId, this.medicoSolicitanteId, this.solicitacaoCirurgia.id)
    return request.success ? request.data : []
  }

  @Action
  async createNovoOPME() {
    const params = {
      hospitalId: this.hospitalId,
      medicoId: this.medicoSolicitanteId,
      descricao: this.novoOPME.descricao,
      possuiGrade: this.novoOPME.possuiGrade,
    }

    try {
      const request = await this.solicitacaoCirurgiaImp.createMedicoOpme(params)
      if (request.success) this.context.dispatch('getMedicoOpme')
      return request.success
    } catch (error) {
      return false
    }
  }

  @Action
  async getMedicoOpme() {
    try {
      const request = await this.solicitacaoCirurgiaImp.getMedicoOpme(this.hospitalId, this.medicoSolicitanteId, this.solicitacaoCirurgia.id)

      if (request.success) {
        this.context.commit('setListaMedicoOpme', request.data.opmes)
        this.context.commit('updateSolicitacaoMaterialOptions')
      }
    } catch (error) {
      this.context.commit('setListaMedicoOpme', [])
    }
  }

  @Action({ commit: 'setProtocoloOPMEsApi', rawError: true })
  async getOpmeSearch(params: any) {
    const { medicoSolicitanteId, hospitalId } = this.solicitacaoCirurgia
    const { convenioId } = this.solicitacaoCirurgia.paciente
    const procedimentosTemp: string[] = []
    procedimentosTemp.push(params.procedimentoPrincipalId)
    this.solicitacaoCirurgia.procedimentosAssociados!.map(p => procedimentosTemp.push(p.id))

    const request = await this.solicitacaoCirurgiaImp
      .getOpmeSearch(medicoSolicitanteId, params.searchText, procedimentosTemp, convenioId || '', hospitalId)

    if (request) {
      return request.data
    }

    return []
  }

  @Action({ commit: 'setMedicoGrupoOpmes', rawError: true })
  async getGrupoOpmeByMedico(codigoProcedimentos: any[]) {
    try {
      const request = await this.solicitacaoCirurgiaImp.getGrupoOpmeByMedico(this.hospitalId, this.medicoSolicitanteId, this.solicitacaoCirurgia.id, codigoProcedimentos)
      return request.success ? request.data.grupoOpmes : []
    } catch (error) {
      return []
    }
  }

  @Action
  async createMedicoGrupoOpme(params: any) {
    try {
      return await this.solicitacaoCirurgiaImp.createMedicoGrupoOpme({ hospitalId: this.hospitalId, ...params })
    } catch (error) {
      return { message: error }
    }
  }

  @Action
  async upsertMedicoGrupoOpme(params: any) {
    try {
      return await this.solicitacaoCirurgiaImp.upsertMedicoGrupoOpme({ hospitalId: this.hospitalId, ...params })
    } catch (error) {
      return { message: error }
    }
  }

  @Action
  async deletarOPMEdoGrupoOPME(params: any) {
    const response = await this.solicitacaoCirurgiaImp.deleteGrupoOpmeDaSolicitacao(params)
    if (response.success) {
      this.context.commit('deleteOpme', params.grupoOpmeDaSolicitacaoId)
    }
    return response
  }

  @Action
  async deleteDeleteGrupoOpmeDaSolicitacao(grupoOpmeId: string) {
    const params: any = {
      solicitacaoId: this.solicitacaoCirurgia.id,
      grupoOpmeDaSolicitacaoId: grupoOpmeId,
    }

    const response = await this.solicitacaoCirurgiaImp.deleteGrupoOpmeDaSolicitacao(params)
    if (response.success) {
      this.context.commit('deleteOpme', grupoOpmeId)
    }
    return response
  }

  @Action({ commit: 'setEquipamentosApi' })
  async getEquipamentoSearch(searchText: string) {
    const { hospitalId } = this.solicitacaoCirurgia
    const response = await this.solicitacaoCirurgiaImp.getEquipamentoSearch(hospitalId, searchText)
    return response
  }

  @Action
  async loadInstrumentos(procedimentoIds: string[]) {
    const { hospitalId } = this.solicitacaoCirurgia
    const response = await this.solicitacaoCirurgiaImp.getAllInstrumentos(procedimentoIds, hospitalId)
    if (response.success) {
      this.context.commit('setInstrumentos', response.data.instrumentosProcedimento)
    }
    return response
  }

  @Action({ commit: 'setGradeMedicaEventos' })
  async getMedicoGradeDeHorario() {
    try {
      const today = (this.solicitacaoCirurgia.opcaoDataPrevisto1 === '' || this.solicitacaoCirurgia.opcaoDataPrevisto1 === null) ? moment() : moment(this.solicitacaoCirurgia.opcaoDataPrevisto1)
      const inicio = today.startOf('week').toISOString()
      const fim = today.endOf('week').subtract(1, 'days').toISOString()

      const params: any = {
        medicoId: this.medicoSolicitanteId,
        hospitalId: this.hospitalId,
        inicio,
        fim,
      }

      const response = await this.solicitacaoCirurgiaImp.getMedicoGradeDeHorario(params)
      return response.success ? response.data.gradeDeHorarios.map((e: any) => convertToGradeMedicaEvento(e)) : []
    } catch (error) {
      return []
    }
  }

  @Action({ commit: 'setGradeMedicaEventos' })
  async getGradeDeHorarioFromCalendar({ inicio, fim }: any) {
    try {
      const params: any = {
        medicoId: this.medicoSolicitanteId,
        hospitalId: this.hospitalId,
        inicio,
        fim,
      }

      const response = await this.solicitacaoCirurgiaImp.getMedicoGradeDeHorario(params)
      return response.success ? response.data.gradeDeHorarios.map((e: any) => convertToGradeMedicaEvento(e)) : []
    } catch (error) {
      return []
    }
  }

  @Action
  async agendarDataCirurgia() {
    try {
      const params: any = {
        solicitacaoId: this.solicitacaoCirurgia.id,
        dataCirurgia: `${this.solicitacaoCirurgia.opcaoDataPrevisto1}:00.000Z`,
        tempoCirurgia: this.solicitacaoCirurgia.tempoCirurgia,
      }

      const response = await this.solicitacaoCirurgiaImp.medicoInformaDataNaGradeDeHorarios(params)
      return response
    } catch (error) {
      return error
    }
  }

  @Action
  async updateProcedimentoBySolicitacaoId(procedimento: any) {
    try {
      const response = await this.solicitacaoCirurgiaImp.updateProcedimentoBySolicitacaoId({ solicitacaoId: this.solicitacaoCirurgia.id, ...procedimento })
      return response
    } catch (error) {
      return { success: false }
    }
  }

  // Adiciona um grupo de opme a solicitação
  // Caso já exista um grupo, faz o merge com os opmes do grupo que recebeu
  // Caso seja protocolo, ele sempre fará a substituição inteira do grupo
  @Mutation
  upsertGrupoDeOpme(value: SolicitacaoGrupoOpme) {
    // Está sendo utilizado slice para manter o mesmo objeto e evitar problemas de renderização na tela
    if (this.solicitacaoCirurgia.protocoloDeCirurgia!.segueOProtocolo === StatusDoProtocoloEnum.segueOProtocolo) {
      // Define o kitDeOpmeId quando for protocolo de cirurgia
      this.solicitacaoCirurgia.protocoloDeCirurgia!.kitDeOpmeId = value.id!

      // Preenche a técnica na solicitação ou remove dependendo se o kit tem ou não tem técnica
      const selectedKitDeOpme = this.selectedProtocolo.kitsDeOpme.find(elem => elem.id === value.id)
      if (selectedKitDeOpme) {
        this.solicitacaoCirurgia.protocoloDeCirurgia!.tecnicaDeCirurgiaId = selectedKitDeOpme.tecnicaDeCirurgia ? selectedKitDeOpme.tecnicaDeCirurgia.id : undefined
      }
    }

    this.solicitacaoCirurgia.grupoDeOpme!.descricao = value.descricao

    // limpa todos opmes do kit, mas mantém opmes opcionais
    const aditionalOpmes = this.solicitacaoCirurgia.grupoDeOpme!.opmes.filter((opme) => {
      return this.opmesOpcionaisOptions.findIndex(item => item.id === opme.id) !== -1
    })
    this.solicitacaoCirurgia.grupoDeOpme!.opmes.splice(0, this.solicitacaoCirurgia.grupoDeOpme!.opmes.length, ...aditionalOpmes)

    // Atualiza os fornecedores
    value.opmes.forEach((opme) => {
      // Se tiver apenas um fornecedor nos fornecedores do opme ou nos fornecedores do protocolo,
      // já seleciona o fornecedor disponível
      if (opme.fornecedores && opme.fornecedores.length === 1) {
        opme.fornecedor1Id = opme.fornecedores[0].fornecedorId
      } else if (
        (this.selectedProtocolo
        && this.selectedProtocolo.fornecedores
        && this.selectedProtocolo.fornecedores.length === 1)
        && !(opme.fornecedores && opme.fornecedores.length > 0)
      ) {
        opme.fornecedor1Id = this.selectedProtocolo.fornecedores[0].fornecedorId
      }

      this.solicitacaoCirurgia.grupoDeOpme!.opmes.push(opme)
    })
  }

  @Action
  upsertGrupoDeOpmeV2(value: IProtocoloKitDeOpmeV2) {
    this.context.commit('upsertGrupoDeOpmeV2Mutation', value)
    this.context.dispatch('protocoloKitDeOpmeV2Change')
  }

  // Adiciona um grupo de opme v2 a solicitação
  // Por ser protocolo sempre fará a substituição inteira do grupo
  @Mutation
  upsertGrupoDeOpmeV2Mutation(value: IProtocoloKitDeOpmeV2) {
    // Está sendo utilizado slice para manter o mesmo objeto e evitar problemas de renderização na tela
    const selectedKitDeOpme = value
    this.solicitacaoCirurgia.protocoloDeCirurgia!.kitDeOpmeId = value.id!
    this.solicitacaoCirurgia.grupoDeOpme!.descricao = value.nome

    // Preenche a técnica na solicitação ou remove dependendo se o kit tem ou não tem técnica
    this.solicitacaoCirurgia.protocoloDeCirurgia!.tecnicaDeCirurgiaId = selectedKitDeOpme.tecnicaDeCirurgia ? selectedKitDeOpme.tecnicaDeCirurgia.id : undefined

    // limpa todos opmes da solicitacao
    this.solicitacaoCirurgia.grupoDeOpme!.opmes.splice(0, this.solicitacaoCirurgia.grupoDeOpme!.opmes.length)

    // Atualiza os fornecedores
    value.materiais.forEach((opme) => {
      // Se tiver apenas um fornecedor nos fornecedores do opme
      // já seleciona o fornecedor disponível
      if (opme.fornecedores && opme.fornecedores.length === 1) {
        opme.selectedFornecedorId = opme.fornecedores[0].fornecedorId

        // Se tiver apenas um material disponivel ja seleciona também
        if (opme.materiaisCodificados && opme.materiaisCodificados.length === 1) {
          opme.selectedMaterialCodificado = opme.materiaisCodificados[0]!
        }
      }
    })

    this.selectedProtocoloKitV2 = value as IProtocoloKitDeOpmeV2Solicitacao

    // Cria os materiais por grupo do kit do protocolo v2
    if (
      this.selectedProtocoloKitV2.materiais
    ) {
      const materialsMap = new Map<string, IProtocoloMaterialDoKitV2Solicitacao[]>()

      this.selectedProtocoloKitV2.materiais.forEach((elem) => {
        const materialGroup = elem.grupoDeMaterial || ''
        const materials = materialsMap.get(materialGroup) || []

        if (materials.length === 0) {
          materialsMap.set(materialGroup, materials)
        }

        materials.push(elem)
      })

      const materiaisPorGrupo: IProtocoloMateriaisPorGrupoV2Solicitacao[] = []

      materialsMap.forEach((materiais, key) => {
        let group: IProtocoloMaterialAgrupado | undefined
        if (this.selectedProtocoloKitV2.materiaisAgrupados) {
          group = this.selectedProtocoloKitV2.materiaisAgrupados.find(elem => elem.id === key)
        }

        if (group) {
          materiaisPorGrupo.push({
            ...group,
            materiais,
          })
        } else {
          materiaisPorGrupo.push({
            materiais,
          } as IProtocoloMateriaisPorGrupoV2Solicitacao)
        }
      })

      this.selectedProtocoloKitV2.materiaisPorGrupo = materiaisPorGrupo
    }
  }

  @Action
  deleteOpme(index: number) {
    this.solicitacaoCirurgia.grupoDeOpme!.opmes.splice(index, 1)
    this.context.commit('updateSolicitacaoMaterialOptions')
  }

  @Mutation
  adicionarOpme() {
    this.solicitacaoCirurgia.grupoDeOpme!.opmes.push({} as any)
  }

  get segueOProtocolo() {
    return this.solicitacaoCirurgia.protocoloDeCirurgia!.segueOProtocolo === StatusDoProtocoloEnum.segueOProtocolo
  }

  get naoSegueOProtocolo() {
    return this.solicitacaoCirurgia.protocoloDeCirurgia!.segueOProtocolo === StatusDoProtocoloEnum.naoSegueOProtocolo
  }

  get naoTemProtocolo() {
    return this.solicitacaoCirurgia.protocoloDeCirurgia!.segueOProtocolo === null
  }

  @Action
  async deleteSolicitacao(id: string) {
    try {
      const request = await this.solicitacaoCirurgiaImp.deleteSolicitacao(id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Mutation
  setCanSuggestProtocol(value: boolean) {
    this.canSuggestProtocol = value
  }

  /**
   * Caixas cirúrgicas
   */
  private caixasCirurgicasApiDefault: CaixaCirurgica[] = []
  public caixasCirurgicasApi: CaixaCirurgica[] = [...this.caixasCirurgicasApiDefault]

  @Mutation
  setCaixasCirurgicasApi(caixasCirurgicas: CaixaCirurgica[]) {
    if (this.solicitacaoCirurgia.caixasCirurgicas.length > 0) {
      Object.entries(this.solicitacaoCirurgia.caixasCirurgicas).forEach(([key, value]) => {
        const index = caixasCirurgicas.findIndex((c: CaixaCirurgica) => c.id === value.id)
        if (![undefined, -1].includes(index)) caixasCirurgicas.splice(index, 1)
      })
    }

    this.caixasCirurgicasApi = caixasCirurgicas
  }

  @Mutation
  clearCaixasCirurgicasApi() {
    this.caixasCirurgicasApi = [...this.caixasCirurgicasApiDefault]
  }

  @Mutation
  addCaixaCirurgicaToSolicitacao(caixaCirurgica: CaixaCirurgica) {
    const index = this.solicitacaoCirurgia.caixasCirurgicas.findIndex((c: CaixaCirurgica) => c.id === caixaCirurgica.id)
    if (![undefined, -1].includes(index)) {
      this.solicitacaoCirurgia.caixasCirurgicas[index] = { ...caixaCirurgica }
    } else {
      this.solicitacaoCirurgia.caixasCirurgicas.push(caixaCirurgica)
    }
  }

  @Mutation
  removeCaixaCirurgicaFromSolicitacao(id: string) {
    const index = this.solicitacaoCirurgia.caixasCirurgicas.findIndex((caixaCirurgica: CaixaCirurgica) => caixaCirurgica.id === id)
    this.solicitacaoCirurgia.caixasCirurgicas.splice(index, 1)
  }

  @Mutation
  removeItemFromCaixaCirurgicaApi(id: string) {
    this.caixasCirurgicasApi.splice(this.solicitacaoCirurgia.caixasCirurgicas.findIndex((caixaCirurgica: CaixaCirurgica) => caixaCirurgica.id === id), 1)
  }

  @Action
  async getAllCaixasCirurgicasByHospitalId(searchText: string = '') {
    try {
      const params = { searchText, hospitalId: this.hospitalId }
      const request = await this.solicitacaoCirurgiaImp.getAllCaixasCirurgicasByHospitalId(params)
      if (request.success) this.context.commit('setCaixasCirurgicasApi', request.data as CaixaCirurgica[] || [])
      return request
    } catch (error) {
      this.context.commit('setCaixasCirurgicasApi', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertCaixaCirurgicaBySolicitacaoId(caixaCirurgica: any) {
    try {
      const request = await this.solicitacaoCirurgiaImp.upsertCaixaCirurgicaBySolicitacaoId({
        ...caixaCirurgica,
        solicitacaoId: this.solicitacaoCirurgia.id,
      })
      if (request.success) {
        this.context.commit('removeItemFromCaixaCirurgicaApi', caixaCirurgica.id)
        this.context.commit('addCaixaCirurgicaToSolicitacao', request.data as CaixaCirurgica)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteCaixaCirurgicaBySolicitacaoId(id: string) {
    try {
      const params: any = { id, solicitacaoId: this.solicitacaoCirurgia.id }
      const request = await this.solicitacaoCirurgiaImp.deleteCaixaCirurgicaBySolicitacaoId(params)
      if (request.success) {
        this.context.commit('removeCaixaCirurgicaFromSolicitacao', id)
        this.context.dispatch('getAllCaixasCirurgicasByHospitalId')
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
  /** */

  /** Anestesistas */
  private paginaDefault: number = 1
  private qtdPorPaginaDefault: number = 10
  public totalAnestesistas: number = 0
  public pagina: number = this.paginaDefault
  public qtdPorPagina: number = this.qtdPorPaginaDefault
  public anestesistaSearchText: string = ''

  @Mutation
  setAnestesistaSearchText(value: string) {
    this.anestesistaSearchText = value
  }

  @Mutation
  setTotalAnestesistas(value: number) {
    this.totalAnestesistas = value
  }

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  setQtdPorPagina(value: number) {
    this.qtdPorPagina = value
  }

  @Mutation
  clearPagination() {
    this.pagina = this.paginaDefault
    this.qtdPorPagina = this.qtdPorPaginaDefault
  }

  public anestesistas: AnestesistaHospital[] = []

  @Mutation
  setAnestesistas(value: AnestesistaHospital[]) {
    this.anestesistas = value
  }

  @Mutation
  clearAnestesistas() {
    this.anestesistas = []
  }

  @Mutation
  setSolicitacaoAnestesista(value: AnestesistaHospital | null) {
    this.solicitacaoCirurgia.anestesista = value
    this.solicitacaoCirurgia.anestesistaId = value ? value.id : null
  }

  @Action
  async getAnestesistas() {
    try {
      const { pagina, qtdPorPagina } = this
      const request = await this.solicitacaoCirurgiaImp.getAllAnestesistas({
        hospitalId: this.solicitacaoCirurgia.hospitalId,
        searchText: this.anestesistaSearchText,
        pagina,
        qtdPorPagina,
      })
      if (request.success) {
        this.context.commit('setAnestesistas', request.data.anestesistas as AnestesistaHospital[] || [])
        this.context.commit('setTotalAnestesistas', request.data.total as number || 0)
      }
      return request
    } catch (error) {
      this.context.commit('setAnestesistas', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async postAnestesista(params: any) {
    try {
      const request = await this.solicitacaoCirurgiaImp.postAnestesista(params)
      if (request.success) await this.context.dispatch('getAllAnestesistas')
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Mutation
  setSolicitacaoCirurgiaFields({ field, value }) {
    this.solicitacaoCirurgia[field] = value
  }

  @Mutation
  setCategoriaCoberturaVigente(value: undefined | boolean) {
    this.solicitacaoCirurgia.paciente.categoriaCoberturaVigente = value
  }

  @Mutation
  setComorbidadesDoPaciente(comorbidades: SolicitacaoComorbidadesDoPaciente[]) {
    this.solicitacaoCirurgia.comorbidadesDoPaciente = comorbidades

    if (comorbidades.length === 0) {
      this.solicitacaoCirurgia.comorbidadesDoPaciente = []
    }
  }

  @Mutation
  removeComorbidadesDoPaciente(comorbidade: string) {
    const index = this.solicitacaoCirurgia.comorbidadesDoPaciente.findIndex(item => item.comorbidade === comorbidade)

    if (index !== -1) {
      this.solicitacaoCirurgia.comorbidadesDoPaciente.splice(index, 1)
    }
    this.setComorbidadesDoPaciente(this.solicitacaoCirurgia.comorbidadesDoPaciente)
  }

  @Mutation
  addComorbidadesDoPaciente(comorbidade: string, informacao: string | null) {
    const novaComorbidade: SolicitacaoComorbidadesDoPaciente = {
      comorbidade,
      informacao,
    }

    this.solicitacaoCirurgia.comorbidadesDoPaciente.push(novaComorbidade)
    this.setComorbidadesDoPaciente(this.solicitacaoCirurgia.comorbidadesDoPaciente)
  }

  @Mutation
  updateComorbidadesDoPacienteInformacao(comorbidadeDoPaciente: any) {
    const index = this.solicitacaoCirurgia.comorbidadesDoPaciente.findIndex(item => item.comorbidade === comorbidadeDoPaciente.comorbidade)
    if (index !== -1) {
      this.solicitacaoCirurgia.comorbidadesDoPaciente[index].informacao = comorbidadeDoPaciente.informacao
    } else {
      const novaComorbidade: SolicitacaoComorbidadesDoPaciente = {
        comorbidade: comorbidadeDoPaciente.comorbidade,
        informacao: comorbidadeDoPaciente.informacao,
      }

      this.solicitacaoCirurgia.comorbidadesDoPaciente.push(novaComorbidade)
    }
    this.setComorbidadesDoPaciente(this.solicitacaoCirurgia.comorbidadesDoPaciente)
  }

  @Action
  async consultaCoberturaVigente(resourceId = '') {
    try {
      const id = this.solicitacaoCirurgia.hospital.tipoDeCoberturaVigente === 'Categoria'
        ? this.solicitacaoCirurgia.paciente.categoriaId
        : resourceId

      const params: any = {
        tipo: this.solicitacaoCirurgia.hospital.tipoDeCoberturaVigente,
        hospitalId: this.hospitalId,
        convenioId: this.solicitacaoCirurgia.paciente.convenioId,
        planoId: this.solicitacaoCirurgia.paciente.planoId,
        id,
      }

      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.consultaCoberturaVigente(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** PROCEDIMENTOS HOSPITAL DIA */
  public todosProcedimentosHospitalDia: boolean = false

  @Mutation
  setTodosProcedimentosHospitalDia(value: boolean) {
    this.todosProcedimentosHospitalDia = value
  }

  @Mutation
  adjustSolicitacaoTOHospitalDiaRules() {
    if (opcaoHabilitadoShared(this.template, 'tipoProcedimento', 'hospitalDia')) this.solicitacaoCirurgia.tipoProcedimento = 'HospitalDia'
    if (campoHabilitadoShared(this.template, 'diaria')) this.solicitacaoCirurgia.diaria = 1
    if (campoHabilitadoShared(this.template, 'reservaUti') && opcaoHabilitadoShared(this.template, 'reservaUti', 'semReservaUti')) this.solicitacaoCirurgia.reservaUTI = 'SemReserva'
    if (campoHabilitadoShared(this.template, 'reservaUti') && opcaoHabilitadoShared(this.template, 'reservaUti', 'reservaUtiNao')) this.solicitacaoCirurgia.reservaUTI = 'ReservaUtiNao'
    if (campoHabilitadoShared(this.template, 'diariaUti')) this.solicitacaoCirurgia.diariaUti = null
  }

  @Action
  async getProcedimentosHospitalDiaByHospital() {
    try {
      const params: any = {
        hospitalId: this.solicitacaoCirurgia.hospitalId,
        convenioId: this.solicitacaoCirurgia.paciente.convenioId,
        procedimentoIds: getProcedimentoIdFromProcedimentos(this.solicitacaoCirurgia.procedimento, this.solicitacaoCirurgia.procedimentosAssociados),
      }

      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getProcedimentosHospitalDiaByHospital(params)
      if (request.success) this.context.commit('setTodosProcedimentosHospitalDia', request.data.todosProcedimentosHospitalDia as boolean)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  // #region Documentos obrigatórios

  @Mutation
  toggleDocumentosObrigatorios(value: boolean) {
    if (value) {
      this.solicitacaoCirurgia.checklistDocumentosObrigatorios = {
        documentosObrigatorios: this.documentosObrigatoriosOptions,
        confirmaQueAnexouOsDocumentos: true,
      }
    } else {
      this.solicitacaoCirurgia.checklistDocumentosObrigatorios = {
        documentosObrigatorios: [],
        confirmaQueAnexouOsDocumentos: false,
      }
    }
  }

  get medicoConfirmaQueAnexouOsDocumentos() {
    if (
      this.solicitacaoCirurgia.checklistDocumentosObrigatorios
      && this.solicitacaoCirurgia.checklistDocumentosObrigatorios.confirmaQueAnexouOsDocumentos
    ) {
      return true
    }
    return false
  }

  // #endregion Documentos obrigatórios

  get isRequiredChooseTecnicaDeCirurgia() {
    if (this.segueOProtocolo && this.selectedProtocolo && this.selectedProtocolo.kitsDeOpme) {
      // If exists any kit without tecnica return is not required
      const existsAnyKitWithoutTecnica = !!this.selectedProtocolo!.kitsDeOpme.find(elem => !elem.tecnicaDeCirurgia)
      if (existsAnyKitWithoutTecnica) {
        return false
      }

      if (
        this.protocoloTecnicaDeCirurgiaOptions
        && this.protocoloTecnicaDeCirurgiaOptions.length > 0
      ) {
        return true
      }
    }

    return false
  }

  // #region Permissions

  get canShowCriarOpmeBtn() {
    return this.naoTemProtocolo || this.naoSegueOProtocolo
  }

  get canShowCadastrarFornecedoresOpmeBtn() {
    return this.naoTemProtocolo || this.naoSegueOProtocolo
  }

  get canShowFornecedoresAdicionaisOpme() {
    return this.naoTemProtocolo || this.naoSegueOProtocolo
  }

  get canShowCadastrarOPMEOpmeBtn() {
    return this.naoTemProtocolo || this.naoSegueOProtocolo
  }

  get canShowAdicionarOutroOpmeBtn() {
    return this.naoTemProtocolo || this.naoSegueOProtocolo
  }

  get canEditNomeOpme() {
    return this.naoTemProtocolo || this.naoSegueOProtocolo
  }

  get canDeleteOpmeDoGrupo() {
    return this.naoTemProtocolo || this.naoSegueOProtocolo
  }

  get canDeleteOpmeDaListaDaCirurgia() {
    return this.naoTemProtocolo || this.naoSegueOProtocolo
  }

  get canShowAddOrEditProcedimentoPrincipalBtn() {
    return true
    // return this.naoTemProtocolo || this.naoSegueOProtocolo
  }

  get canShowDeleteProcedimentoPrincipalBtn() {
    return true
    // return this.naoTemProtocolo || this.naoSegueOProtocolo
  }

  get canShowAddProcedimentosAssociadosBtn() {
    return true
    // return this.naoTemProtocolo || this.naoSegueOProtocolo
  }

  get canShowDeleteProcedimentosAssociadosBtn() {
    return true
    // return this.naoTemProtocolo || this.naoSegueOProtocolo
  }

  get canShowSeloSegueProtocoloDeCirurgia() {
    return this.segueOProtocolo
  }

  get canShowSeloNaoSegueProtocoloDeCirurgia() {
    return this.naoSegueOProtocolo
  }

  get canShowProtocoloDeCirurgiaFields() {
    return this.segueOProtocolo
  }

  get canShowNaoSegueOProtocoloArea() {
    return this.naoSegueOProtocolo
  }

  get canEnableEscolherKitOpmeBtn() {
    return !this.isRequiredChooseTecnicaDeCirurgia
    || (this.isRequiredChooseTecnicaDeCirurgia && this.solicitacaoCirurgia.protocoloDeCirurgia!.tecnicaDeCirurgiaId)
  }

  get canEnableTecnicaDeCirurgiaField() {
    return this.protocoloTecnicaDeCirurgiaOptions && this.protocoloTecnicaDeCirurgiaOptions.length > 0
  }

  get canEditOpmeInfo() {
    return this.naoTemProtocolo || this.naoSegueOProtocolo
  }

  get canEditQuantidadeOpme() {
    return this.naoTemProtocolo || this.naoSegueOProtocolo
  }

  get canShowEditKitOpmeBtn() {
    return this.naoTemProtocolo || this.naoSegueOProtocolo
  }

  get canShowCloneKitOpmeBtn() {
    return this.naoTemProtocolo || this.naoSegueOProtocolo
  }

  get canShowDeleteKitOpmeBtn() {
    return this.naoTemProtocolo || this.naoSegueOProtocolo
  }

  get canShowAdicionarOpmeNaSolicitacaoBtn() {
    const protocoloCirurgiaTemOpmeAdicional: boolean = this.opmesOpcionaisOptions.length > 0
    const protocoloCirurgiaTemQuantidadeMaxima: boolean = this.opmesOpcionaisOptionsMaximumQuantity > 0

    return ((this.naoTemProtocolo || this.naoSegueOProtocolo)
      && this.solicitacaoCirurgia.grupoDeOpme!.opmes.length > 0)
      || (this.segueOProtocolo
      && protocoloCirurgiaTemOpmeAdicional
      && protocoloCirurgiaTemQuantidadeMaxima)
  }

  get canShowCadastrarOpmeNaSolicitacaoBtn() {
    return (this.naoTemProtocolo || this.naoSegueOProtocolo)
      && this.solicitacaoCirurgia.grupoDeOpme!.opmes.length > 0
  }

  get canShowCadastrarFornecedorNaSolicitacaoBtn() {
    return (this.naoTemProtocolo || this.naoSegueOProtocolo)
      && this.solicitacaoCirurgia.grupoDeOpme!.opmes.length > 0
  }

  get canLoadKitDeMaterialDoMedico() {
    return this.naoTemProtocolo || this.naoSegueOProtocolo
  }

  get canShowDocumentosObrigatorios() {
    return this.documentosObrigatoriosOptions
    && this.documentosObrigatoriosOptions.length > 0
  }

  get canShowGrupoDeOpme() {
    return this.selectedProtocoloKitV2 && !this.selectedProtocoloKitV2.nome
    && this.solicitacaoCirurgia.grupoDeOpme && this.solicitacaoCirurgia.grupoDeOpme!.opmes.length > 0
  }

  get canShowGrupoDeOpmeV2() {
    return this.selectedProtocoloKitV2 && this.selectedProtocoloKitV2.nome
  }

  // #endregion Permissions

  /**
   * Tipo Acomodação
   */

  tipoAcomodacaoItems: Array<{ id: string, nome: string }> = [{ id: 'Apartamento', nome: 'Apartamento' }, { id: 'Enfermaria', nome: 'Enfermaria' }]

  @Mutation
  setTipoAcomodacaoItems(items: Array<{ id: string, nome: string }>) {
    this.tipoAcomodacaoItems = items
  }

  @Mutation
  clearTipoAcomodacaoItems() {
    this.tipoAcomodacaoItems = [{ id: 'Apartamento', nome: 'Apartamento' }, { id: 'Enfermaria', nome: 'Enfermaria' }]
  }

  @Action
  async getAllTipoAcomodacao() {
    try {
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllTipoAcomodacao(this.hospitalId)
      if (request.success) {
        this.context.commit('setTipoAcomodacaoItems', request.data
          .filter((item: any) => item.status === 'Ativo')
          .map((item: any) => ({ id: item.id, nome: item.descricao })))
      }
      return request
    } catch (error) {
      this.context.commit('clearTipoAcomodacaoItems')
      return false
    }
  }

  /**
   * Países
  */
  public paises: any[] = []
  public paisesJson: any[] = [...Paises]

  @Mutation
  setPaises(paises: any[]) {
    this.paises = paises.map((pais: any) => ({
      ...pais,
      ddi: this.paisesJson.find((p: any) => p.isoCode === pais.isoCode).ddi,
      mask: this.paisesJson.find((p: any) => p.isoCode === pais.isoCode).mask,
    }))
  }

  @Action({ commit: 'setPaises' })
  async getPaisAllWithHisId() {
    try {
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getPaisAllWithHisId(this.hospitalId)
      return request.success ? request.data as any[] : []
    } catch (error) {
      return []
    }
  }

  /** Clínica de Anestesia */
  public outroAnestesista: string = ''

  @Mutation
  setOutroAnestesista(value: string) {
    this.outroAnestesista = value
  }
}

interface MaterialOptions {
  id: string,
  descricao?: string,
  possuiGrade: boolean,
  disabled: boolean,
}
